/* eslint-disable react-hooks/exhaustive-deps */
import { Box } from "@mui/material";
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import TEXT from "../../../../src/utils/globalText";
import AdditionalRecipient from "../../../components/AdditionalRecipient";
import FullScreen from "../../../components/FullScreen";
import Loader from "../../../components/Loader/Index";
import useServiceChecker from "../../../components/ServiceChecker";
import CommonAlertsStrip from "../../../components/_utils/CommonAlertsStrip";
import CommonBankLogo from "../../../components/_utils/CommonBankLogo";
import SwitcherTabs from "../../../components/_utils/CommonButtons/SwitcherTabs";
import TopNavLargeButton from "../../../components/_utils/CommonButtons/TopNavLargeButton";
import TopNavSmallButton from "../../../components/_utils/CommonButtons/TopNavSmallButton";
import CommonContainerCard from "../../../components/_utils/CommonContainerCard";
import CommonDetailCard from "../../../components/_utils/CommonDetailCard";
import CommonAssignLabelPopup from "../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import EditCommonPopup from "../../../components/_utils/CommonPopups/CommonEditPopup";
import LargePopupRedirect from "../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopup from "../../../components/_utils/CommonSmallPopup";
import SmallPopupWithInput from "../../../components/_utils/CommonSmallPopupWithInput";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent";
import { formatAccountNumber } from "../../../components/_utils/FormatAccountNumber";
import TickerAnimation from "../../../components/_utils/TickerAnimation";
import TitleSubtitlePair from "../../../components/_utils/TitleSubtitlePair";
import UniversalRefreshToast from "../../../components/_utils/UniversalRefreshToast";
import OwnerAccountIFSC from "../../../containers/Accounts/OwnerAccount/OwnerAccountIFSC";
import GSTVerification from "../../../containers/Settings/GSTDetails";
import PanVerification from "../../../containers/Settings/PanVerification";
import {
  resetEditBankBeneficiary,
  resetEditBeneficiary,
} from "../../../redux/features/accounts/BeneficiaryAccount/createAccount";
import {
  addNewLabel,
  beneVerifyThisPAN,
  removeNewLabel,
} from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  beneTxnMultiDeniedApproval,
  beneTxnViewAllAcc,
} from "../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import { resetServices } from "../../../redux/features/refreshToken/refreshToken";
import {
  schedulesTxnReject,
  scheduleTxnView,
} from "../../../redux/features/scheduleTransaction";
import { resetInEdit } from "../../../redux/features/verifyPAN/verifyPAN";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
  ScreenSizeConfiguration,
  TimelineConfiguration,
} from "../../../utils/configurationProvider";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import { linkIdentifier } from "../../../utils/linkIdentifier";
import useCategories from "../../../utils/useCategories";
import DeclinedPopup from "../../Accounts/BeneficiaryAccount/BeneficiaryAcountApproval/DeclinedPopup.jsx";
import FieldForceTransactionViewAll from "../../FieldForceTransactions/FieldForceTransactionsViewAll";
import ICONS from "../../../assets/Icons";
import UserDetailsPopup from "../../../components/Settings/User/UserDetailsPopup/index.jsx";
import CommonToast from "../../../components/_utils/CommonToast";
import {
  archiveFieldForceAccount,
  editFieldForceAccount,
  filedForceApproval,
  filedForceDeniedAccount,
  getSpecificFieldForceAccount,
  resetToggleFfa,
  unarchiveFieldForceAccount,
} from "../../../redux/features/accounts/fieldForceAccount";
import FieldForceAccountViewAll from "../FieldForceAccountViewAll/index.jsx";
import BeneficiaryTransactionViewall from "../../Transactions/BeneficiaryTransactions/BeneficiaryTransactionViewall/index.jsx";
import ScheduleBeneficiaryTransactionViewSchedules from "../../Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionViewSchedules/index.jsx";
import FieldForceAccountAssociatePopup from "../FieldForceAccountViewAll/FieldForceAccountAssociatePopup/index.jsx";

const FieldForceAccountDetails = (payload) => {
  const fieldForceAccountId =
    payload?.field_force_account_id ?? payload?.bene_account_id;
  /** BeneTxnViewall / DeclinedPopup still key off `bene_account_detail_modal`; map only at this boundary. */
  const embeddedBeneTxnModalType =
    payload?.type === "field_force_account_detail_modal"
      ? "bene_account_detail_modal"
      : payload?.type;
  const [ensureAll] = useServiceChecker();
  const categoryMapper = useCategories();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const popupRef = useRef(null);
  const [showLoader, setShowLoader] = useState(false);
  const [clickedBtn, setClickedBtn] = useState(null);
  const [associateschedule] = useState("");
  const [associatePending] = useState("");
  const [showPopupReject, setshowPopupReject] = useState(false);
  const { beneTxnViewAllAccData, beneTxnViewAllAccLoading } = useSelector(
    (state) => state.beneTxnViewAccData,
  );
  const { schedulesTxnViewAllData } = useSelector(
    (state) => state?.schedulesTxnSlice,
  );
  const accountType = location.pathname.includes("beneficiary_account")
    ? "beneficiary"
    : location.pathname.includes("internal_account")
      ? "internal"
      : "";
  const pathName = location?.state?.from ? location?.state?.from : "";
  const txn_single_appr = location?.state?.type ? location?.state?.type : "";

  const [selectedChipIndex, setSelectedChipIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  //useSelector

  const {
    getSpecificFieldForceAccountData,
    getSpecificFieldForceAccountLoading,
  } = useSelector((state) => state.fieldForceAccount);
  /** Detail payload from `getSpecificFieldForceAccount`; ensures `field_force_accounts` is always an array. */
  const viewAccountDetailData = useMemo(() => {
    if (!getSpecificFieldForceAccountData) return null;
    return {
      ...getSpecificFieldForceAccountData,
      field_force_accounts:
        getSpecificFieldForceAccountData.field_force_accounts ?? [],
    };
  }, [getSpecificFieldForceAccountData]);

  const { schedulesTxnViewAllLoading } = useSelector(
    (state) => state?.schedulesTxnSlice,
  );

  const services = useSelector((state) => state.refreshToken.services);

  const sliceCategory = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  );

  const { beneLookData } = useSelector((state) => state.verify);

  const bankData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  //useState
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= ScreenSizeConfiguration?.mobileScreen,
  );
  const [showCategories, setShowCategories] = useState(
    payload?.showCategory ?? false,
  );
  const [showContactDetails, setShowContactDetails] = useState(
    payload?.showCategory ? false : true,
  );
  const [openfieldForceAssociate, setOpenfieldForceAssociate] = useState(false);
  const [unachivedOpenPop, setUnachivedOpenPop] = useState(false);
  const [achivedOpenPop, setAchivedOpenPop] = useState(false);
  const [ViewAccountDetails, SetViewAccountDetails] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [showGstPopup, setGstShowPopup] = useState(false);
  const [showPanPopup, setPanShowPopup] = useState(false);
  const [showIfscPopup, setIfscShowPopup] = useState(false);
  const [deniedId, SetdeniedId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openTransHistory, setOpenTransHistory] = useState(false);
  const [nameArchive, setNameArchive] = useState("");
  const [alertPopUp, setAlertPopUp] = useState(false);
  const [userpopup, setUserpopup] = useState(false);
  const [userid, setUserid] = useState("");
  const serviceCheckUser = JSON.parse(sessionStorage.getItem("response"))
    ?.employees?.id;

  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    name: "",
    bank_name: "",
    ifsc_code: "",
    bank_acc_no: "",
    category: "",
    id: "",
    pan: "",
    bank_account_holder_full_name: "",
  });
  const [openHistory, setOpenHistory] = useState(false);
  const [openInternalAssociate, setOpenInternalAssociate] = useState(false);
  const [openBeneAssociate, setOpenBeneAssociate] = useState(false);
  const [showRejectTnxPopup, setRejectTxnPopup] = useState(false);
  const [showScheduleTxnPopup, setShowScheduleTxnPopup] = useState(false);
  const [preventMultiEnter, setPreventMultiEnter] = useState(false);
  const [showAssignedLabels, setShowAssignedLabels] = useState(false);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [labels, setLabels] = useState([]);
  const [labelLoading, setLabelLoading] = useState(false);
  const [labelDetails, setLabelDetails] = useState([]);
  const [showAdditionalRecipient, setShowAdditionalRecipient] = useState([]);
  const [showAdditionalSection, setShowAdditionalSection] = useState(false);
  const [additionalRecipient, setAdditionalRecipicent] = useState(false);
  const [recipients, setRecipients] = useState([]);
  const [recipientButtonDisabled, setRecipientButtonDisabled] = useState(true);
  const [additionalChip, setAdditionalChip] = useState(showAdditionalRecipient);
  const [declineReason, setDeclineReason] = useState("");
  const [activeType, setActiveType] = useState("pan");
  const [remPan, setRemPan] = useState("");
  const [remAccount, setRemAccount] = useState("");
  const [remIFSC, setRemIFSC] = useState("");
  const Navigate = useNavigate();
  let label;

  const isUppercaseLabel = (value) => {
    if (typeof value !== "string") return false;
    const trimmed = value.trim();
    if (!trimmed) return false;
    return /[A-Z]/.test(trimmed);
  };

  const filterUppercaseLabels = (labelList) =>
    (Array.isArray(labelList) ? labelList : []).filter(
      (labelValue) => !isUppercaseLabel(labelValue),
    );

  const [category, setCategory] = useState("");
  const [bankDetails, setBankDetails] = useState({
    name: "",
    bankAccountNumber: "",
    ifscCode: "",
  });
  const [previousContactDetails, setPreviousContactDetails] = useState({
    legalName: "",
    contact: "",
    email: "",
    gstin: "",
    category: null,
  });

  const [index, setIndex] = useState(
    showContactDetails
      ? GlobalConfiguration?.lengthCheckZero
      : showCategories
        ? GlobalConfiguration?.lengthCheckOne
        : showAssignedLabels
          ? GlobalConfiguration?.lengthCheckTwo
          : additionalRecipient
            ? GlobalConfiguration?.lengthCheckThree
            : GlobalConfiguration?.lengthCheckZero,
  );
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [animationClass, setAnimationClass] = useState("");
  const loadFieldForceDetails = (accountId) =>
    dispatch(getSpecificFieldForceAccount({ id: accountId }));

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  const { beneDeniedApprovalLoading } = useSelector(
    (state) => state.beneAllVerification,
  );
  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.field_force_accounts &&
      viewAccountDetailData.field_force_accounts.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      const { pan_legal_name, contact_no, email_id } =
        viewAccountDetailData.field_force_accounts[
          GlobalConfiguration.lengthCheckZero
        ];
      setPreviousContactDetails({
        legalName: pan_legal_name,
        contact: contact_no,
        email: email_id,

        category: category || null,
      });
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.field_force_accounts &&
      viewAccountDetailData.field_force_accounts.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      const { category } =
        viewAccountDetailData.field_force_accounts[
          GlobalConfiguration.lengthCheckZero
        ];
      setCategory(category);
    }
  }, [viewAccountDetailData]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
    setDeclineReason(sanitizedValue);
  };
  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.field_force_accounts &&
      viewAccountDetailData.field_force_accounts.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      const { bank_acc_no, name, ifsc_code } =
        viewAccountDetailData.field_force_accounts[
          GlobalConfiguration.lengthCheckZero
        ];
      setBankDetails({
        bankHolderName: name,
        bankAccountNumber: bank_acc_no,
        ifscCode: ifsc_code,
      });
    }
  }, [viewAccountDetailData]);

  //function

  function handleChipClick(chipId) {
    setSelectedChipIndex(chipId);
  }

  const chipsArray = [
    {
      text: "IFSC Code",
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckZero,
      disabled: true,
    },
    {
      text: "Name, contact details, linked user, transaction limit",
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckOne,
      disabled: false,
      bulletPoint: ["Require approval."],
      hoverOption: "white",
      onClick: () => handleChipClick(GlobalConfiguration.lengthCheckOne),
    },
    {
      text: "Assigned categories",
      selected: selectedChipIndex === TimelineConfiguration.barWidthMedium,
      disabled: false,
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckTwo),
      hoverOption: "white",
    },
    {
      text: "PAN number, GSTIN",
      selected: selectedChipIndex === 3,
      disabled: false,
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckThree),
      hoverOption: "white",
    },
    {
      text: "Bank account number",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckFour,
      disabled: false,
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckFour),
      hoverOption: "white",
    },
  ];

  const handleApply = () => {
    dispatch(resetServices());

    dispatch(resetEditBeneficiary());
    dispatch(resetEditBankBeneficiary());

    switch (selectedChipIndex) {
      case GlobalConfiguration.lengthCheckZero: // IFSC Code
        break;

      case GlobalConfiguration.lengthCheckOne: // Account name, Contact number, Email
        navigate(
          `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/account_details/${id}`,
          {
            state: previousContactDetails,
          },
        );
        break;

      case GlobalConfiguration.lengthCheckTwo: // Assigned categories
        navigate(
          `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_categories/${id}`,
          {
            state: previousContactDetails,
          },
        );
        break;

      case GlobalConfiguration.lengthCheckThree: // PAN Number, GST
        dispatch(resetInEdit());
        navigate(
          `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_PAN_details/${id}`,
        );
        break;

      case GlobalConfiguration.lengthCheckFour: // Bank account number
        navigate(
          `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_bank_details/${id}`,
          {
            state: bankDetails,
          },
        );
        dispatch(resetEditBankBeneficiary());
        break;

      default:
        break;
    }
  };

  /** Swap `handleEditAccountClick` body to `handleModalOpen(id)` when edit is ready. */
  // eslint-disable-next-line no-unused-vars -- wired when enabling EditCommonPopup from the button
  const handleModalOpen = (editId) => {
    setIsEditModalOpen(editId);
  };

  const handleEditModalClose = () => {
    setIsEditModalOpen(false);
  };

  const handleAlertSchedule = () => {
    setShowScheduleTxnPopup(false);
    setshowPopupReject(true);
  };

  const handleAccRejectAlert = () => {
    setRejectTxnPopup(false);
    setshowPopupReject(true);
  };

  const handleConfirmDecline = async (id, AccountIdData) => {
    // if (payload?.type === "field_force_account_detail_modal") {
    //   actionRestricted();
    //   return;
    // }

    setShowLoader(true);

    UniversalRefreshToast("accountsRefresh");

    if (!beneDeniedApprovalLoading || beneDeniedApprovalLoading === null) {
      const data = await dispatch(
        filedForceDeniedAccount({ id, AccountIdData }),
      );
      if (
        data?.payload?.errors?.user_unauthorized?.length >
        GlobalConfiguration?.lengthCheckZero
      ) {
        Navigate("/feature_not_assigned", {
          state: {
            unavailableService: "FFAAccount",
          },
        });
        return;
      }

      setShowLoader(true);

      await new Promise((resolve) => {
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
      });

      if (data?.payload?.status === false || data?.payload === undefined) {
        let error_msg = "";
        let error_list = null;
        if (data?.payload === undefined) {
          error_msg = "An error occured while taking action on this account";
        } else if (data?.payload?.errors?.field_force_accounts) {
          if (
            data?.payload?.errors?.field_force_accounts?.length >
            GlobalConfiguration?.lengthCheckOne
          ) {
            error_list = data?.payload?.errors?.field_force_accounts;
            error_msg =
              data?.payload?.errors?.field_force_accounts[
                GlobalConfiguration.lengthCheckZero
              ];
          } else {
            error_msg = data?.payload?.errors?.field_force_accounts;
            CommonToast({
              text: error_msg[GlobalConfiguration.lengthCheckZero],
              icon: ICONS?.ERROR_WHITE_CIRCLE,
              variant: "var(--error)",
              buttonNeeded: false,
            });
          }
        } else if (data?.payload?.status === false) {
          error_msg =
            data?.payload?.errors?.category?.[
              GlobalConfiguration.lengthCheckZero
            ];
        } else if (
          data?.payload?.errors?.bank_account_number?.[
            GlobalConfiguration.lengthCheckZero
          ]
        ) {
          error_msg =
            data?.payload?.errors?.bank_account_number[
              GlobalConfiguration.lengthCheckZero
            ];
        }

        if (error_msg === "Field force account already rejected") {
          const newData = await loadFieldForceDetails(id);
          const updatedFieldForceAccount = {
            ...newData?.payload?.field_force_accounts?.[
              GlobalConfiguration.lengthCheckZero
            ],
            error_msg,
            error: data?.payload?.status === false ? true : false,
          };

          const updatedData = ViewAccountDetails?.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                ...(updatedFieldForceAccount || {}),
              };
            }
            return item;
          });
          updateAllAccounts(updatedData);
        } else {
          const updatedData = ViewAccountDetails?.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                error_msg,
                error: data?.payload?.status === false ? true : false,
              };
            }
            return item;
          });
          updateAllAccounts(updatedData);
        }
        setShowLoader(false);
        setDeclineReason("");
        handleClosePopup();
        if (
          Array.isArray(error_list) &&
          error_list.length > GlobalConfiguration?.lengthCheckOne
        ) {
          error_list.forEach((err) => {
            setTimeout(() => {
              CommonToast({
                text: err,
                icon: ICONS?.ERROR_WHITE_CIRCLE,
                variant: "var(--error)",
                buttonNeeded: false,
              });
            }, IntervalConfiguration?.intervalSmall);
          });
        } else {
          CommonToast({
            text: error_msg,
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
      } else {
        const updatedData = ViewAccountDetails?.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "rejected" : "pending",

              rejected_on:
                data?.payload?.status === true
                  ? data?.payload?.field_force_accounts?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.rejected_on
                  : "",
              rejected_by_name:
                data?.payload?.status === true
                  ? data?.payload?.field_force_accounts?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.rejected_by_name
                  : "",
              rejection_reason: AccountIdData,
              error:
                item.error === false && data?.payload?.status === false
                  ? true
                  : false,
              message:
                item.message === "" && data?.payload?.status === false
                  ? data?.payload?.errors?.field_force_accounts?.[
                      GlobalConfiguration.lengthCheckZero
                    ]
                  : "",
            };
          }
          return item;
        });
        updateAllAccounts(updatedData);
        setShowLoader(false);
        setDeclineReason("");
        handleClosePopup();

        CommonToast({
          text: "Field force account rejected successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        if (payload?.type === "field_force_account_detail_modal") {
          setTimeout(() => {
            payload?.closeBeneAccountDetailModal();
            window.location.reload();
          }, IntervalConfiguration.intervalExtraLarge);
        }
        if (pathName) {
          setTimeout(() => {
            Navigate(pathName);
          }, IntervalConfiguration.intervalExtraLarge);
        }
      }
    }
  };

  async function fetchData() {
    if (showLabelsPopup) {
      setLoading(false);
    } else {
      setLoading(true);
    }
    try {
      let response;
      if (payload?.type === "field_force_account_detail_modal") {
        response = await loadFieldForceDetails(fieldForceAccountId);
        setLabelDetails(
          response?.payload?.field_force_accounts?.[
            GlobalConfiguration.lengthCheckZero
          ]?.labels || [],
        );
      } else {
        response = await loadFieldForceDetails(id);
        setLabelDetails(
          response?.payload?.field_force_accounts?.[
            GlobalConfiguration.lengthCheckZero
          ]?.labels || [],
        );
        setShowAdditionalRecipient(
          response?.payload?.field_force_accounts?.[
            GlobalConfiguration.lengthCheckZero
          ]?.recipient_email || [],
        );
        setAdditionalChip(
          response?.payload?.field_force_accounts?.[
            GlobalConfiguration.lengthCheckZero
          ]?.recipient_email || [],
        );
      }
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("/*");
      }
    } catch (error) {
      error("Failed to load the account details", error);
    } finally {
      setLoading(false);
    }
  }
  const finalRecipients = [...new Set([...recipients, ...additionalChip])];

  const handleConfirm = async () => {
    if (recipientButtonDisabled) return;
    const recipientString = [...recipients, ...additionalChip].join(",");
    const targetAccountId = currentAccountDetails?.id || id;
    const primaryFieldForceAccount =
      viewAccountDetailData?.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ];
    const linkedUserId =
      primaryFieldForceAccount?.linked_user_id ||
      primaryFieldForceAccount?.field_force_user_id;
    let response = await dispatch(
      editFieldForceAccount({
        id: targetAccountId,
        recipient_email: recipientString,
        linked_user_id: linkedUserId,
      }),
    );
    if (response?.payload?.status) {
      setShowAdditionalSection(false);
      await fetchData();
      setRecipients([]);
    } else {
      setShowAdditionalSection(false);
    }
  };

  const handleClose = () => {
    setShowLabelsPopup(false);
    fetchData();
  };
  const handlePANDetails = async (pan) => {
    if (pan?.length === GlobalConfiguration?.panLength) {
      const response = await dispatch(
        beneVerifyThisPAN({ search_string: pan }),
      );
      if (response?.payload?.status === true) {
        setPanShowPopup(true);
      } else if (
        response?.payload?.errors?.user_unauthorized?.[
          GlobalConfiguration.lengthCheckZero
        ]
      ) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "BUAccount",
          },
        });
      } else if (response?.payload?.status === false) {
        CommonToast({
          text: response?.payload?.errors?.base[
            GlobalConfiguration.lengthCheckZero
          ],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload?.response?.data?.ids?.unsuccessful_ids?.[
        GlobalConfiguration.lengthCheckZero
      ]?.errors || res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[GlobalConfiguration.lengthCheckZero]) {
      const base = p.errors.base[GlobalConfiguration.lengthCheckZero];
      return typeof base === "string"
        ? base
        : base?.errors?.[GlobalConfiguration.lengthCheckZero] ||
            base?.message ||
            "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLabelLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const res = await dispatch(
      addNewLabel({
        record_ids: toArray(id),
        labels: labelsToAssign,
      }),
    );

    if (addNewLabel.fulfilled.match(res)) {
      fetchData();
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    if (addNewLabel.rejected.match(res)) {
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    setLabelLoading(false);
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const res = await dispatch(
      removeNewLabel({
        record_ids: toArray(id),
        labels: labelsToUnassign,
      }),
    );

    if (removeNewLabel.fulfilled.match(res)) {
      fetchData();
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    if (removeNewLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    setLabelLoading(false);
  };

  const isArchived =
    viewAccountDetailData?.field_force_accounts[
      GlobalConfiguration.lengthCheckZero
    ]?.approval_status === "archived";

  const hasALabel = services?.includes("ALabel");
  const hasRLabel = services?.includes("RLabel");

  const isServiceMissing = !(hasALabel && hasRLabel);

  const handleClick = () => {
    if (isArchived) return;

    if (isServiceMissing) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "ALabel,RLabel" },
      });
    } else {
      setShowLabelsPopup(true);
    }
  };

  if (
    payload.internalAccount === "internalAccount" &&
    services?.find(
      (service) => service === "FFAAccountArchive" || service === "Admin",
    ) === undefined &&
    viewAccountDetailData?.field_force_accounts[
      GlobalConfiguration.lengthCheckZero
    ]?.approval_status === "archived"
  ) {
    label = (
      <>
        Unarchive <br /> account{" "}
      </>
    );
  } else if (payload.internalAccount === "internalAccount") {
    label = (
      <>
        Archive <br /> account{" "}
      </>
    );
  } else if (
    services?.find(
      (service) => service === "FFAAccountArchive" || service === "Admin",
    ) === undefined &&
    viewAccountDetailData?.field_force_accounts[
      GlobalConfiguration.lengthCheckZero
    ]?.approval_status === "archived"
  ) {
    label = (
      <>
        Unarchive <br /> account{" "}
      </>
    );
  } else {
    label = (
      <>
        Archive <br /> account{" "}
      </>
    );
  }

  const handleCloseModal = () => {
    setOpenfieldForceAssociate(false);
    setActiveType("Pan");
    setRemPan(viewAccountDetailData?.field_force_accounts[0]?.pan_no);
    setRemIFSC("");
    setRemAccount("");
  };
  const actionRestricted = () => {
    CommonToast({
      text: "Action restricted in popup mode.",
      icon: ICONS?.ERROR_WHITE_CIRCLE,
      variant: "var(--error)",
    });
  };

  const showFeatureComingSoon = () => {
    CommonToast({
      text: "Feature coming soon",
      icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
      variant: "var(--coming-soon)",
      buttonNeeded: false,
    });
  };

  /** Edit: toast only until edit flow is wired; then call `handleModalOpen(id)` instead of `showFeatureComingSoon()`. */
  const handleEditAccountClick = () => {
    showFeatureComingSoon();
  };

  const handleAssociatedAccountsClick = () => {
    setActiveType("Pan");
    if (payload.type === "field_force_account_detail_modal") {
      actionRestricted();
      return;
    }
    setOpenfieldForceAssociate(true);
  };

  const hasArchiveServiceAccess =
    services?.find(
      (service) => service === "FFAAccountArchive" || service === "Admin",
    ) !== undefined;
  const handleUnarchive = () => {
    if (payload.type === "field_force_account_detail_modal") {
      actionRestricted();
      return;
    }
    if (!hasArchiveServiceAccess) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "FFAAccountArchive" },
      });
      return;
    }
    setUnachivedOpenPop(true);
    if (
      viewAccountDetailData?.field_force_accounts[
        GlobalConfiguration.lengthCheckZero
      ]?.archived === "N"
    ) {
      setUnachivedOpenPop(false);
    } else {
      setUnachivedOpenPop(true);
    }
  };
  const handleArchive = () => {
    if (payload.type === "field_force_account_detail_modal") {
      actionRestricted();
      return;
    }
    if (!hasArchiveServiceAccess) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "FFAAccountArchive" },
      });
      return;
    }
    if (
      viewAccountDetailData?.field_force_accounts[
        GlobalConfiguration.lengthCheckZero
      ]?.archived === "N"
    ) {
      setAchivedOpenPop(true);
    } else {
      setAchivedOpenPop(false);
    }
  };

  const toggleCategories = () => {
    setShowCategories(true);
    setShowContactDetails(false);
    setShowAssignedLabels(false);
    setAdditionalRecipicent(false);
    setIndex(GlobalConfiguration.lengthCheckOne);
  };
  const toggleContactDetails = () => {
    setShowContactDetails(true);
    setShowCategories(false);
    setShowAssignedLabels(false);
    setAdditionalRecipicent(false);
    setIndex(GlobalConfiguration.lengthCheckZero);
  };

  const toggleAssignedLabels = () => {
    setShowAssignedLabels(true);
    setShowCategories(false);
    setShowContactDetails(false);
    setAdditionalRecipicent(false);
    setIndex(GlobalConfiguration.lengthCheckTwo);
  };

  const toggleAdditionalRecipicent = () => {
    setAdditionalRecipicent(true);
    setShowAssignedLabels(false);
    setShowCategories(false);
    setShowContactDetails(false);
    setIndex(GlobalConfiguration.lengthCheckThree);
  };

  const closeTransactionHistory = () => {
    setOpenTransHistory(false);
  };

  const handleTransactionHistoryClick = () => {
    if (payload.type === "field_force_account_detail_modal") {
      actionRestricted();
      return;
    }
    // openTransactionHistory();
    CommonToast({
      text: "Feature coming soon",
      icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
      variant: "var(--coming-soon)",
      buttonNeeded: false,
    });
  };

  const handleRejectAllTransaction = async () => {
    setShowLoader(true);

    const AccountIdData = declineReason;
    let id2 = [];

    id2 =
      !beneTxnViewAllAccLoading &&
      beneTxnViewAllAccData?.transactions?.length >
        GlobalConfiguration?.lengthCheckZero
        ? beneTxnViewAllAccData?.transactions.map((data) => data?.txn_id)
        : [];

    UniversalRefreshToast("Rejecting transaction");

    let data = null;

    if (id2.length > GlobalConfiguration?.lengthCheckZero) {
      data = await dispatch(
        beneTxnMultiDeniedApproval({ id: id2, AccountIdData }),
      );
    } else {
      data = { payload: { status: true } };
    }

    if (
      data?.payload?.status &&
      schedulesTxnViewAllData?.transactions?.length >
        GlobalConfiguration?.lengthCheckZero
    ) {
      setShowScheduleTxnPopup(true);
    } else {
      if (payload.type === "field_force_account_detail_modal") {
        setTimeout(() => {
          handleConfirmDecline(fieldForceAccountId, declineReason);
        }, IntervalConfiguration.intervalSmaller);
      } else {
        setTimeout(() => {
          handleConfirmDecline(id, declineReason);
        }, IntervalConfiguration.intervalSmaller);
      }
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration?.lengthCheckZero
    ) {
      const serviceKey = "ABeneficiaryTxn";

      navigate("/feature_not_assigned", {
        state: { unavailableService: serviceKey },
      });
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration?.intervalExtraLarge),
    );

    if (data?.payload?.status === false) {
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[
            GlobalConfiguration.lengthCheckZero
          ]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(
              data?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]
                ?.errors,
            )
          ? data.payload.errors.base[GlobalConfiguration.lengthCheckZero]
              .errors[GlobalConfiguration.lengthCheckZero]
          : data?.payload?.errors?.base?.[
              GlobalConfiguration.lengthCheckZero
            ] || "Unknown error occurred";
      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      setShowLoader(false);
    } else if (data?.payload?.status) {
      CommonToast({
        text: "Transaction rejected successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occurred while taking action on this account",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setTimeout(() => {
        setRejectTxnPopup(false);
      }, IntervalConfiguration.intervalMedium);
      setDeclineReason("");
    }
  };

  const handleRejectAlert = async () => {
    setShowLoader(true);

    const queryParams = {
      page_no: GlobalConfiguration.lengthCheckOne,
      page_item_count: PaginationConfiguration.paginationSmall,
      lifecycle_status: "pending",
      beneficiary_account_id: id,
    };

    const response = await dispatch(beneTxnViewAllAcc(queryParams));
    const data = response?.payload?.transactions;

    if (
      data?.length > GlobalConfiguration.lengthCheckZero &&
      response?.payload?.status === true
    ) {
      setShowLoader(false);
      handleConfirmAlert(data);
      setRejectTxnPopup(false);
      setshowPopupReject(false);
    }
  };

  const handleConfirmAlert = async (transactions) => {
    try {
      const AccountIdData = declineReason;

      const ids = transactions?.map((t) => t.txn_id) || [];

      UniversalRefreshToast("Rejecting transaction");

      if (ids.length > GlobalConfiguration?.lengthCheckZero) {
        const data = await dispatch(
          beneTxnMultiDeniedApproval({ id: ids, AccountIdData }),
        );

        if (data?.payload?.status === true) {
          CommonToast({
            text: "Transaction(s) rejected successfully.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
          setDeclineReason("");
        }
      }
      await loadFieldForceDetails(id);
      setDeclineReason("");
    } catch (error) {
      CommonToast({
        text: "Something went wrong. Please try again",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  };

  const handleRejectTransactionChecker = async (id, AccountIdData) => {
    setShowLoader(true);

    let response = [];
    let response1 = [];

    let queryParams = {
      page_no: GlobalConfiguration.lengthCheckOne,
      page_item_count: PaginationConfiguration.paginationSmall,
      lifecycle_status: "pending",
      beneficiary_account_id: id,
    };
    response = await dispatch(beneTxnViewAllAcc(queryParams));

    let queryParams1 = {
      page_no: GlobalConfiguration.lengthCheckOne,
      page_item_count: PaginationConfiguration.paginationSmall,
      lifecycle_status: "pending",
      beneficiary_account_id: id,
    };

    response1 = await dispatch(scheduleTxnView(queryParams1));

    const data = response?.payload?.transactions;
    const data1 = response1?.payload?.transactions;
    if (
      data?.length > GlobalConfiguration.lengthCheckZero &&
      response?.payload?.status === true
    ) {
      setRejectTxnPopup(true);
      setShowLoader(false);
      setshowPopupReject(false);
      setPreventMultiEnter(true);
    } else if (
      data1?.length > GlobalConfiguration.lengthCheckZero &&
      response1?.payload?.status === true
    ) {
      setShowScheduleTxnPopup(true);
      setshowPopupReject(false);
      setShowLoader(false);
    } else {
      handleConfirmDecline(id, AccountIdData);
    }
    await loadFieldForceDetails(id);
  };

  const handleLinkedUser = () => {
    if (payload.type === "field_force_account_detail_modal") {
      actionRestricted();
      return;
    }
    const ffAcc =
      viewAccountDetailData?.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ];
    if (!ffAcc?.field_force_user_full_name) {
      // CommonToast({
      //   text: "No user is linked to this account.",
      //   icon: "https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg",
      //   variant: "var(--error)",
      //   btnProps: {
      //     isDisabled: false,
      //     enabledTextColor: "var(--text-primary)",
      //     enabledBgColor: "var(--error)",
      //   },
      // });
      return;
    }

    const hasVSpecificEmp = ensureAll(["VSpecificEmp"])?.status;
    const hasAdmin = ensureAll(["Admin"])?.status;
    const ffUserId = ffAcc?.field_force_user_id || ffAcc?.linked_user_id;

    const canViewLinkedUser =
      (hasVSpecificEmp && ffUserId === serviceCheckUser) ||
      (hasVSpecificEmp && hasAdmin);

    if (canViewLinkedUser && ffUserId) {
      setUserid(ffUserId);
      setUserpopup(true);
      return;
    }

    const unavailableService = !hasVSpecificEmp
      ? "VSpecificEmp"
      : !hasAdmin
        ? "Admin"
        : "VSpecificEmp";

    if (!canViewLinkedUser) {
      navigate("/feature_not_assigned", {
        state: { unavailableService },
      });
    }
  };

  const handleApprovalDetails = async (id) => {
    // if (payload?.type === "field_force_account_detail_modal") {
    //   actionRestricted();
    //   return;
    // }

    setShowLoader(true);
    const targetAccountId =
      payload?.type === "field_force_account_detail_modal"
        ? fieldForceAccountId
        : id;
    let response;
    try {
      UniversalRefreshToast("approvalaccountsRefresh");

      response = await dispatch(filedForceApproval(id));

      if (
        response?.payload?.errors?.user_unauthorized?.length >
        GlobalConfiguration?.lengthCheckZero
      ) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "FFAAccount",
          },
        });
        return;
      }
      if (
        response?.payload?.status === false ||
        response?.payload === undefined
      ) {
        let error_msg = "";
        if (response?.payload === undefined) {
          error_msg = "An error occured while taking action on this account";
        } else if (
          response?.payload?.errors?.field_force_accounts?.[
            GlobalConfiguration.lengthCheckZero
          ]
        ) {
          error_msg =
            response.payload.errors.field_force_accounts[
              GlobalConfiguration.lengthCheckZero
            ];
        } else if (
          response?.payload?.errors?.bank_account_number?.[
            GlobalConfiguration.lengthCheckZero
          ]
        ) {
          error_msg =
            response.payload.errors.bank_account_number[
              GlobalConfiguration.lengthCheckZero
            ];
        } else {
          error_msg = "An unknown error occurred.";
        }
        if (error_msg === "Field force account already approved") {
          const updatedData = viewAccountDetailData?.field_force_accounts.map(
            (item) => {
              if (item.id === targetAccountId) {
                return {
                  ...item,
                  approval_status:
                    item.approval_status === "pending" ? "approved" : "pending",
                };
              }
              return item;
            },
          );
          SetViewAccountDetails(updatedData);

          if (payload?.type === "field_force_account_detail_modal") {
            await loadFieldForceDetails(fieldForceAccountId);
          } else {
            await loadFieldForceDetails(id);
          }
        } else {
          const updatedData = viewAccountDetailData?.field_force_accounts.map(
            (item) => {
              if (item.id === targetAccountId) {
                return {
                  ...item,
                  approval_status:
                    item.approval_status === "pending" ? "pending" : "",
                  error_msg,
                };
              }
              return item;
            },
          );

          SetViewAccountDetails(updatedData);
        }
        CommonToast({
          text: error_msg,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else {
        const updatedData = viewAccountDetailData?.field_force_accounts.map(
          (item) => {
            if (item.id === targetAccountId) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "approved" : "pending",
              };
            }
            return item;
          },
        );
        SetViewAccountDetails(updatedData);

        if (payload?.type === "field_force_account_detail_modal") {
          await loadFieldForceDetails(fieldForceAccountId);
        } else {
          await loadFieldForceDetails(id);
        }
        const successMessage = "Field force account approved successfully.";
        CommonToast({
          text: successMessage,
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        if (payload?.type === "field_force_account_detail_modal") {
          setTimeout(() => {
            payload?.closeBeneAccountDetailModal();
            window.location.reload();
          }, IntervalConfiguration?.intervalExtraLarger);
        }
        if (pathName) {
          setTimeout(() => {
            navigate(pathName);
          }, IntervalConfiguration?.intervalPopup);
        }

        if (txn_single_appr === "txn_single_approval") {
          setTimeout(() => {
            navigate(IntervalConfiguration?.navigate_back);
          }, IntervalConfiguration?.intervalExtraLarger);
        }
      }
    } finally {
      setShowLoader(false);
      setClickedBtn(null);
    }
  };

  const handleDeclinedDetials = (declineId) => {
    // if (payload?.type === "field_force_account_detail_modal") {
    //   actionRestricted();
    //   return;
    // }
    setshowPopupReject(true);
    SetdeniedId(declineId);
  };

  const handlecloseSchedule = () => {
    setShowPopup(false);
  };
  const handleClosePopup = () => {
    setRejectTxnPopup(false);
    setShowPopup(false);
    setshowPopupReject(false);
    if (payload?.type !== "field_force_account_detail_modal") {
      setPreventMultiEnter(false);
      if (payload?.type === "scheduleAcc") {
        setShowScheduleTxnPopup(false);
      }
    }
    setDeclineReason("");
  };
  const updateAllAccounts = (updatedAccounts) => {
    SetViewAccountDetails(updatedAccounts);
  };

  const handleAccountSelection = (beneAccountId) => {};

  const handleArchiveButton = async () => {
    if (!hasArchiveServiceAccess) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "FFAAccountArchive" },
      });
      return;
    }
    const acc =
      viewAccountDetailData?.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ];
    if (!acc) return;

    const pendingTxn =
      acc.pending_transactions === "Y" ||
      acc.pending_field_force_transactions === "Y";
    const pendingSched =
      acc.pending_scheduled_transactions === "Y" ||
      acc.pending_scheduled_field_force_transactions === "Y";

    if (pendingTxn) {
      setAchivedOpenPop(false);
      CommonToast({
        text: "Reject pending transactions before archiving this account. Use the alerts strip or pending-transaction flow.",
        icon: ICONS.INFO_FILLED,
        variant: "var(--processing)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      return;
    }
    if (pendingSched) {
      setAchivedOpenPop(false);
      CommonToast({
        text: "Reject pending scheduled transactions before archiving this account.",
        icon: ICONS.INFO_FILLED,
        variant: "var(--processing)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      return;
    }

    UniversalRefreshToast("archive");
    const archived_response = await dispatch(archiveFieldForceAccount({ id }));
    if (archiveFieldForceAccount.fulfilled.match(archived_response)) {
      await loadFieldForceDetails(id);
    }
    handleCloseModal();
    setAchivedOpenPop(false);
  };

  const handleUnArchiveButton = async () => {
    if (!hasArchiveServiceAccess) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "FFAAccountArchive" },
      });
      return;
    }
    UniversalRefreshToast("unarchive");
    const unarchived_response = await dispatch(
      unarchiveFieldForceAccount({ id }),
    );
    if (unarchiveFieldForceAccount.fulfilled.match(unarchived_response)) {
      await loadFieldForceDetails(id);
    }
    handleCloseModal();
  };

  // useEffect

  useEffect(() => {
    fetchData();
    let availableLabels = sessionStorage?.getItem("AvailableLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(filterUppercaseLabels(parsedLabels));
  }, [fieldForceAccountId, id, dispatch]);

  useEffect(() => {
    if (viewAccountDetailData) {
      SetViewAccountDetails(viewAccountDetailData?.field_force_accounts);
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.field_force_accounts &&
      viewAccountDetailData.field_force_accounts.length >
        GlobalConfiguration?.lengthCheckZero
    ) {
      const { bank_name, bank_acc_no, category, ifsc_code, id, pan_no, name } =
        viewAccountDetailData.field_force_accounts[
          GlobalConfiguration.lengthCheckZero
        ];
      setCurrentAccountDetails({
        bank_name,
        bank_acc_no,
        category,
        ifsc_code,
        id,
        pan: pan_no,
        bank_account_holder_full_name: name,
        name: name,
      });
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= ScreenSizeConfiguration?.mobileScreen);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    let accountData = [];
    if (viewAccountDetailData) {
      accountData =
        viewAccountDetailData?.field_force_accounts[
          GlobalConfiguration.lengthCheckZero
        ].logs;
    }
    if (
      accountData &&
      viewAccountDetailData?.field_force_accounts[
        GlobalConfiguration.lengthCheckZero
      ].archived === "Y"
    ) {
      setNameArchive(
        [...accountData]
          .filter((fil) => {
            return fil.action === "Archived";
          })
          .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))[
          GlobalConfiguration.lengthCheckZero
        ]?.user_full_name,
      );
    }
  }, [ViewAccountDetails]);

  useEffect(() => {
    if (beneLookData || bankData) {
      if (
        beneLookData?.total_count > GlobalConfiguration?.lengthCheckOne ||
        bankData?.total_count > GlobalConfiguration?.lengthCheckOne
      ) {
      }
    }
  }, [beneLookData, bankData]);

  useEffect(() => {
    sessionStorage.removeItem("PAN GST Edit NewValue");
  }, []);

  const handleRejectScheduleTxn = async () => {
    let id2 =
      !schedulesTxnViewAllLoading &&
      schedulesTxnViewAllData?.transactions?.length >
        GlobalConfiguration?.lengthCheckZero
        ? schedulesTxnViewAllData?.transactions.map((data) => data?.txn_id)
        : [];
    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      let data2 = await dispatch(
        schedulesTxnReject({
          id: id2,
          reason: declineReason,
          services,
        }),
      );
      if (data2?.payload?.status === false) {
        const error_msg2 = data2?.payload?.errors?.user_unauthorized
          ? data2?.payload?.errors?.user_unauthorized[
              GlobalConfiguration.lengthCheckZero
            ]
          : Array.isArray(data2?.payload?.errors?.base) &&
              Array.isArray(
                data2?.payload?.errors?.base[
                  GlobalConfiguration.lengthCheckZero
                ]?.errors,
              )
            ? data2.payload.errors.base[GlobalConfiguration.lengthCheckZero]
                .errors[GlobalConfiguration.lengthCheckZero]
            : data2?.payload?.errors?.base?.[
                GlobalConfiguration.lengthCheckZero
              ] || "Unknown error occurred";
        CommonToast({
          text: error_msg2,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });

        setShowLoader(false);
      } else if (data2?.payload?.status === true) {
        setShowScheduleTxnPopup(false);
        CommonToast({
          text: "Scheduled transactions rejected successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        setTimeout(() => {
          setShowScheduleTxnPopup(false);
        }, IntervalConfiguration.intervalExtraLarge);

        if (associateschedule !== "AlertSchedule") {
          if (payload.type === "field_force_account_detail_modal") {
            handleConfirmDecline(fieldForceAccountId, declineReason);
          } else {
            handleConfirmDecline(id, declineReason);
          }
        }
        if (payload?.type === "field_force_account_detail_modal") {
          await loadFieldForceDetails(fieldForceAccountId);
        } else {
          await loadFieldForceDetails(id);
        }
      }
      setDeclineReason("");
      setshowPopupReject(false);
    }
  };

  const primaryFieldForceAccount =
    viewAccountDetailData?.field_force_accounts?.[
      GlobalConfiguration.lengthCheckZero
    ];

  const hasAssociatedAccountsFound =
    primaryFieldForceAccount?.associate_bank === "Y" ||
    primaryFieldForceAccount?.associate_pan === "Y";

  const hasPendingTransactionsFound =
    primaryFieldForceAccount?.pending_transactions === "Y" ||
    primaryFieldForceAccount?.pending_field_force_transactions === "Y";

  const hasPendingSchedulesFound =
    primaryFieldForceAccount?.pending_scheduled_transactions === "Y" ||
    primaryFieldForceAccount?.pending_scheduled_field_force_transactions ===
      "Y";

  const hasAllCategoriesAssigned =
    primaryFieldForceAccount?.all_category_assign === "Y";

  const buildAlerts = () => [
    ...(hasAllCategoriesAssigned !== undefined
      ? hasAllCategoriesAssigned
        ? [
            {
              isLoading: false,
              isDisabled: payload?.type === "field_force_account_detail_modal",
              text: "All categories are assigned to this account",
              icon: "https://q2pay.in/new_assets/common/dashboard/alert.svg",
              onClick: () => {
                if (payload?.type === "field_force_account_detail_modal") {
                  actionRestricted();
                  return;
                }
                toggleCategories();
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking category assign",
          },
        ]),
    ...(hasAssociatedAccountsFound
      ? [
          {
            isLoading: false,
            isDisabled: payload?.type === "field_force_account_detail_modal",
            text: "Associated accounts are found",
            icon: ICONS?.ALERT,
            onClick: () => {
              if (payload?.type === "field_force_account_detail_modal") {
                actionRestricted();

                return;
              }
              handleAssociatedAccountsClick();
            },
          },
        ]
      : []),
    ...(hasPendingTransactionsFound &&
    primaryFieldForceAccount?.approval_status === "pending"
      ? [
          {
            isLoading: false,
            isDisabled: payload?.type === "field_force_account_detail_modal",
            text: "Pending transactions found",
            icon: ICONS?.ALERT,
            onClick: () => {
              if (payload?.type === "field_force_account_detail_modal") {
                actionRestricted();
                return;
              }
              // const hasAccess =
              //   services?.includes("ABeneficiaryTxn") ||
              //   services?.includes("Admin");
              // if (!hasAccess) {
              //   navigate("/feature_not_assigned", {
              //     state: { unavailableService: "ABeneficiaryTxn" },
              //   });
              //   return;
              // }
              // setassociatePending("AlertPendingTxn");
              // setassociateschedule("");
              // setRejectTxnPopup(true);
              CommonToast({
                text: "Feature coming soon",
                icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
                variant: "var(--coming-soon)",
                buttonNeeded: false,
              });
            },
          },
        ]
      : []),
    ...(hasPendingSchedulesFound &&
    primaryFieldForceAccount?.approval_status === "pending"
      ? [
          {
            isLoading: false,
            text: "Pending schedules found",
            isDisabled: payload?.type === "field_force_account_detail_modal",
            icon: ICONS?.ALERT,
            onClick: () => {
              if (payload?.type === "field_force_account_detail_modal") {
                actionRestricted();
                return;
              }
              // const hasAccess =
              //   services?.includes("BAScheduledTxn") ||
              //   services?.includes("Admin");
              // if (!hasAccess) {
              //   navigate("/feature_not_assigned", {
              //     state: { unavailableService: "BAScheduledTxn" },
              //   });
              //   return;
              // }
              // setassociateschedule("AlertSchedule");
              // setassociatePending("");
              // setShowScheduleTxnPopup(true);

              CommonToast({
                text: "Feature coming soon",
                icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
                variant: "var(--coming-soon)",
                buttonNeeded: false,
              });
            },
          },
        ]
      : []),
  ];

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  return (
    <>
      {showAdditionalSection && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <AdditionalRecipient
            finalRecipients={finalRecipients}
            setShowAdditionalSection={setShowAdditionalSection}
            accountID={id}
            showAdditionalRecipient={showAdditionalRecipient}
            setShowAdditionalRecipient={setShowAdditionalRecipient}
            handleConfirm={handleConfirm}
            recipients={recipients}
            setRecipients={setRecipients}
            buttonDisabled={recipientButtonDisabled}
            setButtonDisabled={setRecipientButtonDisabled}
            additionalChip={additionalChip}
            setAdditionalChip={setAdditionalChip}
          />
        </div>
      )}
      {showGstPopup && (
        <LargePopupRedirect
          headerTitle="GST Details"
          isfullViewrequired={true}
          fullviewhandleFunction={() =>
            navigate(`/settings/GST_verification`, {
              state:
                ViewAccountDetails?.[GlobalConfiguration.lengthCheckZero]
                  ?.gstin_detail,
            })
          }
          closeiconhandleFunction={() => setGstShowPopup(false)}
        >
          <GSTVerification
            gst_number={
              ViewAccountDetails?.[GlobalConfiguration.lengthCheckZero]
                ?.gstin_detail
            }
            popup={true}
          />
        </LargePopupRedirect>
      )}

      {showIfscPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="IFSC Details"
            headersubtext="The following shows IFSC details for the associated account."
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(
                `/settings/IFSC_verification/IFSC_Details/${ViewAccountDetails?.[GlobalConfiguration.lengthCheckZero]?.ifsc_code}`,
              )
            }
            closeiconhandleFunction={() => setIfscShowPopup(false)}
          >
            <OwnerAccountIFSC
              ifsc_code={
                ViewAccountDetails?.[GlobalConfiguration.lengthCheckZero]
                  ?.ifsc_code
              }
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      {showPanPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="PAN Details"
            headersubtext="The following shows PAN details of the associated account."
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(`/settings/PAN_verification`, {
                state:
                  ViewAccountDetails?.[GlobalConfiguration.lengthCheckZero]
                    ?.pan_no,
              })
            }
            closeiconhandleFunction={() => setPanShowPopup(false)}
          >
            <PanVerification
              pan_no={
                ViewAccountDetails?.[GlobalConfiguration.lengthCheckZero]
                  ?.pan_no
              }
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}

      {alertPopUp && (
        <div className="fixed top-top-base left-left-base w-full h-full flex items-center bg-Primary-black justify-center z-z-index-max bg-dark-opacity">
          <FullScreen
            id={fieldForceAccountId}
            setAlertPopUp={setAlertPopUp}
          />
        </div>
      )}
      {userpopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-max-zindex bg-custom-backdrop bg-opacity-dark-opacity">
          <UserDetailsPopup
            User_account_id={userid}
            type="User_details"
            closeBeneAccountDetailModal={() => {
              setUserpopup(false);
            }}
          />
        </div>
      )}
      {/* {openHistory && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-dark-opacity">
          <TransactionHistory
            onClose={() => setOpenHistory(false)}
            Owner_account_number={
              viewAccountDetailData?.field_force_accounts[
                GlobalConfiguration.lengthCheckZero
              ]?.bank_acc_no
            }
            internalAccount={true}
            OwnerDetail={true}
            BeneAccId={id}
          />
        </div>
      )} */}
      <div
        id="webviewdetailPage"
        className={`${
          payload?.type === "field_force_account_detail_modal"
            ? "h-height-full"
            : ""
        }`}
      >
        <div
          className={`main-div flex flex-col ${payload.type === "field_force_account_detail_modal" ? " h-full" : "h-screen"}  ${
            achivedOpenPop || isEditModalOpen
              ? "overflow-hidden"
              : payload.type === "field_force_account_detail_modal"
                ? " overflow-x-hidden"
                : "overflow-y-auto overflow-x-hidden"
          }`}
        >
          {showRejectTnxPopup && (
            <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-custom-backdrop bg-dark-opacity">
              <div ref={popupRef}>
                <LargePopupRedirect
                  headerTitle="Associated transactions found"
                  headersubtext="The following transactions are linked and need to be rejected before rejecting this account."
                  closeiconenabledBgColor="var(--primary-nav)"
                  closeiconisLoading={false}
                  closeiconhandleFunction={() => {
                    setRejectTxnPopup(false);
                    setDeclineReason("");
                  }}
                  closeicon={
                    "https://q2pay.in/new_assets/common/create_flow/close.svg"
                  }
                  closeiconhoverOption="white"
                  closeiconbtnType={"button"}
                  closeiconisDisabled={false}
                  closeicondisabledBgColor={""}
                  closeiconbuttonRef={null}
                  closeicontitle={"Close"}
                  btnType={"button"}
                  bottomHeaderTextNeed={true}
                  bottomHeaderText={
                    "To reject the account, please reject the transactions listed above by clicking the “Reject all” button. The transactions will get rejected with the provided rejected reason."
                  }
                  isbottomSectionneed={true}
                  btnText={"Reject all"}
                  confirmbtnrequired={true}
                  handleFunction={() => {
                    if (associatePending === "AlertPendingTxn") {
                      handleAccRejectAlert();
                    } else {
                      handleRejectAllTransaction();
                    }
                  }}
                  enabledBgColor={"var(--negative-act)"}
                  hoverOption={"dark"}
                  outLineColor={""}
                  enabledTextColor={"var(--text-primary)"}
                  fullWidthRequired={false}
                  isDisabled={false}
                  disabledTextColor={""}
                  disabledBgColor={""}
                >
                  {showRejectTnxPopup && (
                    <>
                      {" "}
                      <BeneficiaryTransactionViewall
                        bene_account_id={id || fieldForceAccountId}
                        typepop={"BeneAccRejectTxn"}
                        flowType={
                          payload?.type === "scheduleAcc"
                            ? "scheduleAcc"
                            : associatePending === "AlertPendingTxn"
                              ? "AlertPendingTxn"
                              : "decline account details"
                        }
                        closeRejectAllTxn={handleClosePopup}
                        bene_account_name={
                          viewAccountDetailData?.field_force_accounts[
                            GlobalConfiguration.lengthCheckZero
                          ]?.name
                        }
                        handleRejectAllTransaction={
                          associatePending === "AlertPendingTxn"
                            ? handleAccRejectAlert
                            : handleRejectAllTransaction
                        }
                        type={
                          embeddedBeneTxnModalType ||
                          "bene_account_detail_modal"
                        }
                        setShowLoader={setShowLoader}
                        setSidebarState={(e) => {}}
                        setShowScheduleTxnPopup={setShowScheduleTxnPopup}
                        showLoader={showLoader}
                        setFocus={(e) => {}}
                      />
                    </>
                  )}
                </LargePopupRedirect>
              </div>
            </div>
          )}
          {showScheduleTxnPopup && (
            <div
              className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-custom-backdrop bg-dark-opacity"
              ref={popupRef}
            >
              <LargePopupRedirect
                headerTitle="Associated schedules found"
                headersubtext="The following schedules are linked and need to be rejected before rejecting this account."
                closeiconenabledBgColor="var(--primary-nav)"
                closeiconisLoading={false}
                closeiconhandleFunction={() => {
                  setShowScheduleTxnPopup(false);
                  setDeclineReason("");
                }}
                closeicon={
                  "https://q2pay.in/new_assets/common/create_flow/close.svg"
                }
                closeiconhoverOption="white"
                closeiconbtnType={"button"}
                closeiconisDisabled={false}
                closeicondisabledBgColor={""}
                closeiconbuttonRef={null}
                closeicontitle={"Close"}
                btnType={"button"}
                bottomHeaderTextNeed={true}
                bottomHeaderText={
                  "To reject the account, please reject the schedules listed above by clicking the “Reject all” button. The schedules will get rejected with the provided rejected reason."
                }
                isbottomSectionneed={true}
                btnText={"Reject all"}
                confirmbtnrequired={true}
                handleFunction={() => {
                  if (associateschedule === "AlertSchedule") {
                    handleAlertSchedule();
                  } else {
                    handleRejectScheduleTxn();
                  }
                }}
                enabledBgColor={"var(--negative-act)"}
                hoverOption={"dark"}
                outLineColor={""}
                enabledTextColor={"var(--text-primary)"}
                fullWidthRequired={false}
                isDisabled={false}
                disabledTextColor={""}
                disabledBgColor={""}
              >
                <ScheduleBeneficiaryTransactionViewSchedules
                  // isPopup={true}

                  type={"ScheduleAccBeneAcc"}
                  payload={{
                    schedule_acc_id: id || fieldForceAccountId,
                    number: "swadfsafs",

                    schedule_acc_name:
                      viewAccountDetailData?.field_force_accounts[
                        GlobalConfiguration.lengthCheckZero
                      ]?.name,
                    handleRejectAllTransaction:
                      associateschedule === "AlertSchedule"
                        ? handleAlertSchedule
                        : handleRejectScheduleTxn,
                  }}
                  closeCallback={handleClosePopup}
                />
              </LargePopupRedirect>
            </div>
          )}
          {loading ? (
            <div className="loader-container m-auto justify-center items-center flex">
              <Loader />
            </div>
          ) : (
            <>
              <div
                className={`bene_detail_heder_containerm ${payload?.type === "field_force_account_detail_modal" && "hidden"} Qmd:hidden`}
              >
                <TopNavComponent
                  topNavHeader={"Field force"}
                  isFormattingNotRequired
                  topNavSubText="Account details"
                  handleBack={(e) => {
                    navigate(GlobalConfiguration.navigate_back);
                  }}
                />
              </div>
              <div
                className={` h-auto Qmd:bg-primary-nav bg-primary-card ${
                  payload?.type === "field_force_account_detail_modal"
                    ? null
                    : "main-alignment"
                }`}
              >
                {showPopup && (
                  <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
                    <DeclinedPopup
                      type={
                        payload?.internalAccount === "internalAccount"
                          ? "internalAccount"
                          : payload?.type === "scheduleAcc"
                            ? "scheduleAcc"
                            : "decline account details"
                      }
                      onClose={handleClosePopup}
                      handlecloseSchedule={handlecloseSchedule}
                      accountId={deniedId}
                      beneid={id}
                      associateschedule={associateschedule}
                      associatePending={associatePending}
                      id={
                        payload?.type === "field_force_account_detail_modal"
                          ? fieldForceAccountId
                          : id
                      }
                      accountName={
                        viewAccountDetailData?.field_force_accounts[
                          GlobalConfiguration.lengthCheckZero
                        ]?.name
                      }
                      allAccounts={ViewAccountDetails}
                      updateAllAccounts={updateAllAccounts}
                      showRejectTnxPopup={showRejectTnxPopup}
                      setRejectTxnPopup={setRejectTxnPopup}
                      preventMultiEnter={preventMultiEnter}
                      setPreventMultiEnter={setPreventMultiEnter}
                      modaltype={
                        payload?.type === "field_force_account_detail_modal"
                          ? "bene_account_detail_modal"
                          : ""
                      }
                      closeBeneAccountDetailModal={
                        payload?.closeBeneAccountDetailModal
                      }
                      txn_single_appr={txn_single_appr}
                      showScheduleTxnPopup={showScheduleTxnPopup}
                      setShowScheduleTxnPopup={setShowScheduleTxnPopup}
                    />
                  </div>
                )}

                {showPopupReject && (
                  <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
                    <SmallPopupWithInput
                      headerTitle="Rejected reason"
                      headerFontWeight="semibold"
                      headerFontColor="text-primary"
                      textSize="font-md"
                      secondHeaderTitle="Please state the reason for rejecting the account."
                      secondHeaderFontWeight="normal"
                      secondHeaderFontColor="text-secondary"
                      secondHeaderTextSize="font-xs"
                      // noteText="The reason must consist of at least 10 characters."
                      noteColor="text-secondary"
                      inputPlaceholder="Reason (10-150 char)"
                      inputVariant={computeVariant(declineReason, isFocused)}
                      inputOnFocus={(e) => setIsFocused(true)}
                      inputOnBlur={(e) => setIsFocused(false)}
                      inputIsDisabled={showLoader ? true : false}
                      btnOneIsDisabled={showLoader ? true : false}
                      inputBgColor="var(--primary-bg)"
                      inputFgColor="var(--text-secondary)"
                      inputOnInput={(e) => {
                        if (!showLoader) {
                          handleInputChange(e);
                        }
                      }}
                      inputValue={declineReason}
                      inputFontKind="small"
                      inputIsFullWidth={true}
                      btnOneText="Cancel"
                      btnOneHandleFunction={() => {
                        if (!showLoader) {
                          handleClosePopup();
                        }
                      }}
                      btnOneEnabledBgColor="var(--primary-bg)"
                      btnOneOutLineColor="var(--text-primary)"
                      btnOneEnabledTextColor="var(--text-primary)"
                      btnOneHoverOption="white"
                      btnTwoText="Reject"
                      btnTwoHandleFunction={() => {
                        if (associatePending === "AlertPendingTxn") {
                          handleRejectAlert();
                        } else if (associateschedule === "AlertSchedule") {
                          handleRejectScheduleTxn();
                        } else {
                          handleRejectTransactionChecker(
                            deniedId,
                            declineReason,
                          );
                        }
                      }}
                      btnTwoEnabledBgColor="var(--negative-act)"
                      btnTwoEnabledTextColor="var(--text-primary)"
                      btnTwoIsDisabled={
                        !declineReason ||
                        declineReason.length < GlobalConfiguration?.panLength
                      }
                      btnTwoDisabledBgColor="var(--text-disabled)"
                      btnTwoIsLoaderNeeded={showLoader ? true : false}
                      btnTwoIsLoading={showLoader ? true : false}
                      btnTwoHoverOption="black"
                      btnTwoInActiveVariantNeeded={true}
                    />
                  </div>
                )}

                {/* {openAssociatedAccounts && (
                  <div className="fixed top-top-base left-left-base w-full h-full bg-PopUp-BackDrop bg-dark-opacity flex items-center justify-center z-z-index-modal">
                    <BeneViewAssociatedAccount
                      onAsscociateClose={closeAssociatedAccountsFound}
                      IFSC={currentAccountDetails.ifsc_code}
                      accountNumber={currentAccountDetails.bank_acc_no}
                      beneAccountId={currentAccountDetails.id}
                      panNumber={currentAccountDetails.pan}
                      onAccountSelect={handleAccountSelection}
                      accountName={currentAccountDetails.name}
                      toggleContactDetails={toggleContactDetails}
                    />
                  </div>
                )} */}

                {openfieldForceAssociate && (
                  <FieldForceAccountAssociatePopup
                    handleClick={handleClick}
                    handleCloseModal={handleCloseModal}
                    showModalPopup={openfieldForceAssociate}
                    createFieldForceAccountLoading={
                      getSpecificFieldForceAccountLoading
                    }
                    accountNumber={
                      viewAccountDetailData?.field_force_accounts[0].bank_acc_no
                    }
                    ifsc={
                      viewAccountDetailData?.field_force_accounts[0].ifsc_code
                    }
                    panNumber={
                      viewAccountDetailData?.field_force_accounts[0].pan_no
                    }
                    setActiveType={setActiveType}
                    setRemPan={setRemPan}
                    setRemAccount={setRemAccount}
                    setRemIFSC={setRemIFSC}
                    remIFSC={remIFSC}
                    remAccount={remAccount}
                    remPan={remPan}
                    activeType={activeType}
                    isBottomRequired={false}
                    id={viewAccountDetailData?.field_force_accounts?.[0]?.id}
                  />
                )}
                {openBeneAssociate && (
                  <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
                    <LargePopupRedirect
                      headerTitle="Associated accounts"
                      headersubtext="The accounts listed below are linked to the selected field force account."
                      closeiconenabledBgColor="var(--primary-nav)"
                      closeiconisLoading={false}
                      closeiconhandleFunction={() => {
                        dispatch(resetToggleFfa());
                        setRemPan("");
                        setRemAccount("");
                        setRemIFSC("");
                        setActiveType("pan");
                        setOpenBeneAssociate(false);
                      }}
                      closeicon={
                        "https://q2pay.in/new_assets/common/create_flow/close.svg"
                      }
                      closeiconhoverOption="white"
                      closeiconbtnType={"button"}
                      closeiconisDisabled={false}
                      closeicondisabledBgColor={""}
                      closeiconbuttonRef={null}
                      closeicontitle={"Close"}
                      btnType={"button"}
                      confirmbtnrequired={true}
                      enabledBgColor={"var(--negative-act)"}
                      hoverOption={"dark"}
                      outLineColor={""}
                      enabledTextColor={"var(--text-primary)"}
                      fullWidthRequired={false}
                      isDisabled={false}
                      disabledTextColor={""}
                      disabledBgColor={""}
                      ispanbankRequired={true}
                      togglepan={() => {
                        setActiveType("pan");
                        setRemPan(currentAccountDetails?.pan ?? "");
                        setRemAccount("");
                        setRemIFSC("");
                      }}
                      toggleBank={() => {
                        setActiveType("bank");
                        setRemPan("");
                        setRemAccount(currentAccountDetails?.bank_acc_no ?? "");
                        setRemIFSC(currentAccountDetails?.ifsc_code ?? "");
                      }}
                    >
                      <FieldForceAccountViewAll
                        id={
                          viewAccountDetailData?.field_force_accounts?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.id
                        }
                        type={"fieldForceAccount"}
                        popupType={"associated"}
                        remPan={remPan}
                        remAccount={remAccount}
                        remIFSC={remIFSC}
                        setOpenBeneAssociate={setOpenBeneAssociate}
                        openBeneAssociate={openBeneAssociate}
                        restrictAssociatedAccountNavigation={
                          payload?.type === "field_force_account_detail_modal"
                        }
                      />
                    </LargePopupRedirect>
                  </div>
                )}

                {unachivedOpenPop && (
                  <div
                    onClick={() => setUnachivedOpenPop(false)}
                    className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity"
                  >
                    <SmallPopup
                      headerTitle={"Unarchive account"}
                      subtext="Are you sure you want to unarchive this account?"
                      btnOneText="Cancel"
                      btnOneBtnType="button"
                      btnOneEnabledBgColor="transparent"
                      btnOneHandleFunction={handleCloseModal}
                      btnOneOutLineColor="var(--text-primary)"
                      btnOneEnabledTextColor="var(--text-primary)"
                      btnOneIsDisabled={false}
                      btnOneHoverOption="white"
                      btnTwoText="Unarchive"
                      btnTwoBtnType="button"
                      btnTwoHandleFunction={handleUnArchiveButton}
                      btnTwoEnabledBgColor="var(--positive-act)"
                      btnTwoEnabledTextColor="var(--text-primary)"
                      btnTwoIsDisabled={false}
                      btnTwoHoverOption="black"
                      // noteText="This account will become active."
                    />
                  </div>
                )}
                {achivedOpenPop && (
                  <div
                    onClick={() => setAchivedOpenPop(false)}
                    className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity"
                  >
                    <div>
                      <SmallPopup
                        headerTitle={"Archive account"}
                        headerFontWeight="semibold"
                        headerFontColor="text-primary"
                        textSize="font-md"
                        subtext="Are you sure you want to archive this account??"
                        btnOneText="Cancel"
                        btnOneBtnType="button"
                        btnOneEnabledBgColor="transparent"
                        btnOneHandleFunction={handleCloseModal}
                        btnOneOutLineColor="var(--text-primary)"
                        btnOneEnabledTextColor="var(--text-primary)"
                        btnOneIsDisabled={false}
                        btnOneHoverOption="white"
                        btnTwoText="Archive"
                        btnTwoBtnType="button"
                        btnTwoHandleFunction={handleArchiveButton}
                        btnTwoEnabledBgColor="var(--negative-act)"
                        btnTwoEnabledTextColor="var(--text-primary)"
                        btnTwoIsDisabled={false}
                        btnTwoHoverOption="black"
                        // noteText="This account will become inactive."
                      />
                    </div>
                  </div>
                )}

                {openTransHistory && (
                  <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-dark-opacity">
                    <LargePopupRedirect
                      headerTitle={"Transaction history"}
                      headersubtext={
                        "All transactions related to the beneficiary are listed below."
                      }
                      closeiconenabledBgColor="var(--primary-nav)"
                      closeiconisLoading={false}
                      closeiconhandleFunction={() => closeTransactionHistory()}
                      closeicon={
                        "https://q2pay.in/new_assets/common/create_flow/close.svg"
                      }
                      closeiconhoverOption="white"
                      closeiconbtnType={"button"}
                      closeiconisDisabled={false}
                      closeicondisabledBgColor={""}
                      closeiconbuttonRef={null}
                      closeicontitle={"Close"}
                      btnType={"button"}
                      enabledBgColor={"var(--negative-act)"}
                      hoverOption={"dark"}
                      outLineColor={""}
                      enabledTextColor={"var(--text-primary)"}
                      fullWidthRequired={false}
                      isDisabled={false}
                      disabledTextColor={""}
                      disabledBgColor={""}
                    >
                      <FieldForceTransactionViewAll
                        bene_account_name={
                          viewAccountDetailData?.field_force_accounts[
                            GlobalConfiguration.lengthCheckZero
                          ]?.name
                        }
                        bene_account_id={
                          viewAccountDetailData?.field_force_accounts[
                            GlobalConfiguration.lengthCheckZero
                          ]?.id
                        }
                        bene_account_confidential={null}
                        onClose={closeTransactionHistory}
                        // typepop={"transactionHistorypopup"}
                        typepop={"txnHistorypopup"}
                        // popup={modalType}
                        // category={
                        //   isCategoryName
                        //     ? beneTxnAccountData?.transaction[GlobalConfiguration.lengthCheckZero]?.category
                        //     : ""
                        // }
                        // label={{
                        //   ...(isAccName
                        //     ? { label: "accountName" }
                        //     : isCategoryName
                        //       ? { label: "categoryName" }
                        //       : {}),
                        // }}
                      />
                    </LargePopupRedirect>
                  </div>
                )}

                {showLabelsPopup && (
                  <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
                    <CommonAssignLabelPopup
                      headerTitle="Assign/unassign labels:"
                      headersubtext="Labels will be used to generate statistics for the associated accounts."
                      closehandleFunction={handleClose}
                      closeisDisabled={false}
                      labels={labels}
                      setLabels={setLabels}
                      LabelAccounts={id}
                      isLabelPopupOpen={showLabelsPopup}
                      filteredData={viewAccountDetailData?.field_force_accounts?.map(
                        (account) => ({
                          ...account,
                          labels: filterUppercaseLabels(account?.labels),
                        }),
                      )}
                      onClose={handleClose}
                      loading={labelLoading}
                      setLoading={setLabelLoading}
                      handleAssignLabels={handleAssignLabelsProp}
                      handleUnassignLabels={handleUnassignLabelsProp}
                    />
                  </div>
                )}
                <div
                  className={`w-full max-w-screen-Qlg m-auto Qmd:bg-primary-nav bg-primary-card ${payload?.type === "field_force_account_detail_modal" ? "" : "Qlg:mt-margin-sm"} `}
                  id="container"
                >
                  <div className="flex w-full bg-primary-nav  m-auto h-height-sm">
                    <div
                      className={`w-[inherit]  ${
                        payload?.type === "field_force_account_detail_modal"
                          ? ""
                          : "mt-margin-base Qmd:mt-margin-lg"
                      }`}
                    >
                      <div className="Qmd:grid ff-acc-detail-grid flex flex-col">
                        {viewAccountDetailData?.field_force_accounts.map(
                          (account) => (
                            <div
                              key={account.id}
                              className="flex border-b border-solid border-primary-bg justify-between"
                            >
                              {account?.name?.toLowerCase().trim() ===
                                account?.pan_legal_name?.toLowerCase().trim()}
                              <div className="flex flex-col Qmd:flex-row w-full  items-center ">
                                <div className="py-padding-md w-full Qmd:w-right-half border-b Qmd:border-b-border-base border-solid border-primary-bg">
                                  <div className="flex flex-col Qmd:border-r border-solid border-primary-bg pl-padding-sm">
                                    <TitleSubtitlePair
                                      title={account.name.trim()}
                                      titleColor="text-primary "
                                      subtitle={
                                        account?.name?.toLowerCase().trim() ===
                                        account?.pan_legal_name
                                          ?.toLowerCase()
                                          .trim()
                                          ? "Account name - Using legal name"
                                          : "Account name"
                                      }
                                      alignRight={false}
                                      hoverOption="white"
                                      isBold={false}
                                      variant="md"
                                    />
                                  </div>
                                </div>

                                {ViewAccountDetails?.map((account) => (
                                  <div
                                    key={account.id}
                                    className="w-full Qmd:w-right-half py-padding-md"
                                  >
                                    <div className="flex flex-col items-start pl-padding-sm Qmd:pl-padding-md">
                                      <TitleSubtitlePair
                                        title={
                                          account?.approval_status === "error"
                                            ? "Pending"
                                            : account?.approval_status
                                                ?.toLowerCase()
                                                ?.split(" ")
                                                ?.map(
                                                  (word) =>
                                                    word
                                                      .charAt(
                                                        GlobalConfiguration?.lengthCheckZero,
                                                      )
                                                      .toUpperCase() +
                                                    word.slice(
                                                      GlobalConfiguration?.lengthCheckOne,
                                                    ),
                                                )
                                                ?.join(" ")
                                        }
                                        titleColor={`${
                                          account.approval_status ===
                                            "pending" ||
                                          account.approval_status === "error"
                                            ? "pending"
                                            : account.approval_status ===
                                                "approved"
                                              ? "awaiting"
                                              : account.approval_status ===
                                                  "rejected"
                                                ? "failed"
                                                : account.approval_status ===
                                                    "blocked"
                                                  ? "failed"
                                                  : account.approval_status ===
                                                      "archived"
                                                    ? "abandoned"
                                                    : ""
                                        }`}
                                        subtitle="Account status"
                                        alignRight={false}
                                        hoverOption="white"
                                        isBold={true}
                                        variant="md"
                                      />
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ),
                        )}
                        <div>
                          <div className="h-full Qmd:flex flex-row bg-primary-nav-act hidden justify-end items-center border-b border-primary-bg">
                            <TopNavSmallButton
                              btnText={
                                <>
                                  Linked <br /> user
                                </>
                              }
                              handleFunction={handleLinkedUser}
                              icon="https://q2pay.in/new_assets/common/detail_page/linked_white_circle.svg"
                              enabledBgColor={"var(--primary-nav-act)"}
                              enabledTextColor={"var(--text-primary)"}
                              disabledBgColor={"var(--primary-nav-act)"}
                              disabledTextColor={"var(--text-primary)"}
                              isDisabled={
                                payload.type ===
                                "field_force_account_detail_modal"
                                  ? true
                                  : services?.find(
                                        (service) =>
                                          service === "VSpecificEmp" ||
                                          service === "Admin",
                                      ) !== undefined &&
                                      viewAccountDetailData
                                        ?.field_force_accounts?.[
                                        GlobalConfiguration.lengthCheckZero
                                      ]?.field_force_user_full_name
                                    ? false
                                    : viewAccountDetailData
                                          ?.field_force_accounts?.[
                                          GlobalConfiguration.lengthCheckZero
                                        ]?.field_force_user_full_name
                                      ? false
                                      : true
                              }
                              hoverOption="white"
                            />

                            <span className=" border-l border-primary-bg h-topnavheight">
                              {" "}
                            </span>
                            <TopNavSmallButton
                              btnText={
                                <>
                                  Associated <br /> accounts
                                </>
                              }
                              handleFunction={handleAssociatedAccountsClick}
                              icon="https://q2pay.in/new_assets/common/detail_page/associated_accounts_found.svg"
                              enabledBgColor={"var(--primary-nav-act)"}
                              enabledTextColor={"var(--text-primary)"}
                              disabledBgColor={"var(--primary-nav-act)"}
                              disabledTextColor={"var(--text-primary)"}
                              isDisabled={
                                payload.type ===
                                "field_force_account_detail_modal"
                              }
                              hoverOption="white"
                            />
                            <span className=" border-l border-primary-bg h-topnavheight">
                              {" "}
                            </span>
                            <TopNavSmallButton
                              btnText={
                                <>
                                  Transaction <br /> history
                                </>
                              }
                              handleFunction={handleTransactionHistoryClick}
                              icon="https://q2pay.in/new_assets/common/detail_page/transaction_history.svg"
                              enabledBgColor={"var(--primary-nav-act)"}
                              enabledTextColor={"var(--text-primary)"}
                              disabledBgColor={"var(--primary-nav-act)"}
                              disabledTextColor={"var(--text-primary)"}
                              hoverOption="white"
                              isDisabled={
                                payload.type ===
                                "field_force_account_detail_modal"
                              }
                            />
                          </div>
                        </div>
                        {viewAccountDetailData?.field_force_accounts.map(
                          (account) => (
                            <div
                              key={account.id}
                              className="bene-account-holder-details flex border-b border-solid border-primary-bg justify-between"
                            >
                              <div className="flex flex-col Qmd:flex-row w-full ">
                                <div className="py-padding-md pl-padding-sm flex flex-col w-full Qmd:w-right-half Qmd:border-b-border-base border-b border-solid border-primary-bg">
                                  <div className="flex justify-between ">
                                    <TitleSubtitlePair
                                      title={(() => {
                                        const accNo =
                                          account.bank_acc_no ??
                                          account.bank_account_no;
                                        if (
                                          accNo == null ||
                                          String(accNo).trim() === ""
                                        ) {
                                          return "—";
                                        }
                                        return formatAccountNumber(
                                          String(accNo),
                                        );
                                      })()}
                                      titleColor="text-primary"
                                      subtitle="  Account number"
                                      alignRight={false}
                                      hoverOption="white"
                                      isBold={false}
                                      variant="md"
                                    />
                                    {/* ---------------------------- */}
                                    <div className="h-[max-content]  bg-text-primary rounded-border-radius-md px-padding-sm py-padding-button-s  mr-margin-md">
                                      <CommonBankLogo
                                        ifsc={
                                          account?.ifsc_code || account?.ifsc
                                        }
                                        variant="big"
                                      />
                                    </div>
                                  </div>

                                  {/* -------------------------------- */}
                                </div>
                                <div className="py-padding-md w-full Qmd:w-right-half">
                                  <div className="flex flex-col items-start pl-padding-sm Qmd:pl-padding-md Qmd:border-l border-l-border-base border-solid border-primary-bg">
                                    <TitleSubtitlePair
                                      title={(
                                        account.bank_account_holder_full_name ||
                                        account.name ||
                                        ""
                                      )
                                        ?.toLowerCase()
                                        ?.split(" ")
                                        ?.map(
                                          (word) =>
                                            word
                                              .charAt(
                                                GlobalConfiguration?.lengthCheckZero,
                                              )
                                              .toUpperCase() +
                                            word.slice(
                                              GlobalConfiguration?.lengthCheckOne,
                                            ),
                                        )
                                        ?.join(" ")}
                                      titleColor="text-primary"
                                      subtitle=" Bank account holder name"
                                      alignRight={false}
                                      hoverOption="white"
                                      isBold={false}
                                      variant="md"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ),
                        )}
                        <div>
                          <div className="h-full Qmd:flex flex-row  hidden justify-end items-center border-b border-primary-bg">
                            <div className="h-full Qmd:flex flex-row  hidden justify-end items-center bg-primary-nav-act">
                              <div className="">
                                {services?.find(
                                  (service) =>
                                    service === "BUAccount" ||
                                    service === "Admin",
                                ) === undefined ||
                                viewAccountDetailData?.field_force_accounts[
                                  GlobalConfiguration.lengthCheckZero
                                ].approval_status === "archived" ||
                                viewAccountDetailData?.field_force_accounts[
                                  GlobalConfiguration.lengthCheckZero
                                ].approval_status === "blocked" ? (
                                  <>
                                    <TopNavSmallButton
                                      btnText={
                                        <>
                                          Edit <br /> account
                                        </>
                                      }
                                      handleFunction={() => {
                                        if (
                                          viewAccountDetailData
                                            ?.field_force_accounts[
                                            GlobalConfiguration.lengthCheckZero
                                          ].approval_status !== "archived" &&
                                          viewAccountDetailData
                                            ?.field_force_accounts[
                                            GlobalConfiguration.lengthCheckZero
                                          ].approval_status !== "blocked"
                                        ) {
                                          if (
                                            services?.find(
                                              (service) =>
                                                service === "BUAccount" ||
                                                (service === "Admin" &&
                                                  payload?.servicesType !==
                                                    "BenAdmin"),
                                            ) !== undefined
                                          ) {
                                            handleEditAccountClick();
                                          } else {
                                            navigate("/feature_not_assigned", {
                                              state: {
                                                unavailableService: "BUAccount",
                                              },
                                            });
                                          }
                                        }
                                      }}
                                      icon={
                                        "https://q2pay.in/new_assets/common/detail_page/edit_with_white_circle.svg"
                                      }
                                      enabledBgColor={"var(--primary-nav-act)"}
                                      enabledTextColor={"var(--text-primary"}
                                      hoverOption="white"
                                      isDisabled={
                                        payload.type ===
                                          "field_force_account_detail_modal" ||
                                        viewAccountDetailData
                                          ?.field_force_accounts[
                                          GlobalConfiguration.lengthCheckZero
                                        ].approval_status === "archived" ||
                                        viewAccountDetailData
                                          ?.field_force_accounts[
                                          GlobalConfiguration.lengthCheckZero
                                        ].approval_status === "blocked"
                                      }
                                    />
                                  </>
                                ) : (
                                  <>
                                    <TopNavSmallButton
                                      btnText={
                                        <>
                                          Edit <br /> account
                                        </>
                                      }
                                      handleFunction={() => {
                                        if (
                                          payload?.type !==
                                          "field_force_account_detail_modal"
                                        ) {
                                          if (
                                            services?.find(
                                              (service) =>
                                                service === "BUAccount" ||
                                                service === "Admin",
                                            ) !== undefined
                                          ) {
                                            handleEditAccountClick();
                                          } else {
                                            navigate("/feature_not_assigned", {
                                              state: {
                                                unavailableService: "BUAccount",
                                              },
                                            });
                                          }
                                        } else if (
                                          payload.type ===
                                          "field_force_account_detail_modal"
                                        ) {
                                          actionRestricted();
                                        }
                                      }}
                                      icon={
                                        "https://q2pay.in/new_assets/common/detail_page/edit_with_white_circle.svg"
                                      }
                                      enabledBgColor={"var(--primary-nav-act)"}
                                      enabledTextColor={"var(--text-primary"}
                                      hoverOption="white"
                                      isDisabled={
                                        payload.type ===
                                        "field_force_account_detail_modal"
                                      }
                                    />

                                    {isEditModalOpen && (
                                      <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
                                        <EditCommonPopup
                                          btnOneHandleFunction={
                                            handleEditModalClose
                                          }
                                          headerTitle="Select the option you would like to edit:"
                                          alertText="Make sure you understand the impact before archiving."
                                          alertBackground="emphasis"
                                          chipsArray={chipsArray}
                                          btnOneText="Cancel"
                                          btnOneEnabledBgColor="var(--primary-bg)"
                                          btnOneEnabledTextColor="var(--text-primary)"
                                          btnOneHoverOption="white"
                                          btnOneOutLineColor="var(--text-primary)"
                                          btnTwoText="Edit"
                                          btnTwoHandleFunction={handleApply}
                                          btnTwoIsDisabled={
                                            selectedChipIndex === null
                                          }
                                          btnTwoEnabledBgColor="var(--text-primary)"
                                          btnTwoEnabledTextColor="var(--primary-bg)"
                                          btnTwoDisabledBgColor="var(--text-disabled)"
                                          btnTwoHoverOption="black"
                                        />
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                              <span className="border-r border-primary-bg h-topnavheight"></span>{" "}
                              {viewAccountDetailData?.field_force_accounts[
                                GlobalConfiguration.lengthCheckZero
                              ].approval_status === "blocked" ||
                              services?.find(
                                (service) =>
                                  service === "FFAAccountArchive" ||
                                  service === "Admin",
                              ) === undefined ? (
                                <>
                                  <TopNavSmallButton
                                    btnText={label}
                                    handleFunction={() => {
                                      if (
                                        viewAccountDetailData
                                          ?.field_force_accounts[
                                          GlobalConfiguration.lengthCheckZero
                                        ].approval_status !== "blocked"
                                      ) {
                                        if (
                                          services?.find(
                                            (service) =>
                                              service === "FFAAccountArchive" ||
                                              service === "Admin",
                                          ) !== undefined
                                        ) {
                                          handleUnarchive();
                                          handleArchive();
                                        } else {
                                          navigate("/feature_not_assigned", {
                                            state: {
                                              unavailableService:
                                                "FFAAccountArchive",
                                            },
                                          });
                                        }
                                      }
                                    }}
                                    icon={
                                      services?.find(
                                        (service) =>
                                          service === "FFAAccountArchive" ||
                                          service === "Admin",
                                      ) === undefined &&
                                      viewAccountDetailData
                                        ?.field_force_accounts[
                                        GlobalConfiguration.lengthCheckZero
                                      ].approval_status === "archived"
                                        ? "https://q2pay.in/new_assets/common/detail_page/unarchive.svg"
                                        : "https://q2pay.in/new_assets/common/detail_page/archive.svg"
                                    }
                                    enabledBgColor={"var(--primary-nav-act)"}
                                    enabledTextColor={"var(--text-primary)"}
                                    hoverOption="white"
                                    isDisabled={
                                      payload.type ===
                                        "field_force_account_detail_modal" ||
                                      viewAccountDetailData
                                        ?.field_force_accounts[
                                        GlobalConfiguration.lengthCheckZero
                                      ].approval_status === "blocked"
                                    }
                                  />
                                </>
                              ) : (
                                <TopNavSmallButton
                                  btnText={
                                    viewAccountDetailData?.field_force_accounts[
                                      GlobalConfiguration.lengthCheckZero
                                    ].approval_status === "archived" ? (
                                      <>
                                        Unarchive <br /> account{" "}
                                      </>
                                    ) : (
                                      <>
                                        Archive <br /> account{" "}
                                      </>
                                    )
                                  }
                                  handleFunction={() => {
                                    if (
                                      payload?.type !==
                                      "field_force_account_detail_modal"
                                    ) {
                                      if (
                                        services?.find(
                                          (service) =>
                                            service === "FFAAccountArchive" ||
                                            service === "Admin",
                                        ) !== undefined
                                      ) {
                                        handleUnarchive();
                                        handleArchive();
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService:
                                              "FFAAccountArchive",
                                          },
                                        });
                                      }
                                    } else if (
                                      payload.type ===
                                      "field_force_account_detail_modal"
                                    ) {
                                      actionRestricted();
                                    }
                                  }}
                                  icon={
                                    viewAccountDetailData?.field_force_accounts[
                                      GlobalConfiguration.lengthCheckZero
                                    ].approval_status === "archived"
                                      ? "https://q2pay.in/new_assets/common/detail_page/archive.svg"
                                      : "https://q2pay.in/new_assets/common/detail_page/unarchive.svg"
                                  }
                                  enabledBgColor={"var(--primary-nav-act)"}
                                  enabledTextColor={"var(--text-primary"}
                                  hoverOption="white"
                                  isDisabled={
                                    payload.type ===
                                    "field_force_account_detail_modal"
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        {viewAccountDetailData?.field_force_accounts.map(
                          (account) => (
                            <div
                              key={account.id}
                              className="bene-account-holder-details flex border-solid border-primary-bg justify-between"
                            >
                              <div className="flex flex-col Qmd:flex-row w-full ">
                                <div className=" flex flex-col w-full Qmd:w-right-half Qmd:border-b-border-base border-b border-solid border-primary-bg">
                                  <div className="flex flex-row items-center">
                                    <div className="flex justify-between w-full my-margin-sm ">
                                      <TitleSubtitlePair
                                        title={
                                          account?.ifsc_code || account?.ifsc
                                        }
                                        titleColor="text-primary "
                                        isDisabled={
                                          payload.type ===
                                          "field_force_account_detail_modal"
                                            ? true
                                            : false
                                        }
                                        subtitle="IFSC code"
                                        alignRight={false}
                                        hoverOption="white"
                                        isBold={false}
                                        variant="md"
                                        showArrow="true"
                                        onClick={() => {
                                          if (
                                            services?.find(
                                              (service) =>
                                                service === "VIFSC" ||
                                                service === "Admin",
                                            ) !== undefined &&
                                            (account.ifsc_code || account.ifsc)
                                          ) {
                                            if (
                                              payload.type ===
                                              "field_force_account_detail_modal"
                                            ) {
                                              actionRestricted();
                                            } else {
                                              setIfscShowPopup(true);
                                            }
                                          } else {
                                            navigate("/feature_not_assigned", {
                                              state: {
                                                unavailableService: "VIFSC",
                                              },
                                            });
                                          }
                                        }}
                                      />

                                      {/* <div className="h-[max-content] flex justify-center items-center bg-text-primary rounded-border-radius-md my-margin-md px-padding-sm py-padding-button-s  mr-margin-md">
                                        <CommonBankLogo
                                          ifsc={
                                            account?.ifsc_code || account?.ifsc
                                          }
                                          variant="big"
                                        />
                                      </div> */}
                                    </div>
                                  </div>
                                </div>
                                {/* <div className="py-padding-md w-full Qmd:w-right-half">
                                  <div
                                    className={`flex flex-col ${!account?.field_force_custom_limit && "hidden"} items-start   pl-padding-sm Qmd:pl-padding-md Qmd:border-l border-l-border-base border-solid border-primary-bg`}
                                  >
                                    <TitleSubtitlePair
                                      title={
                                        account?.field_force_custom_limit !=
                                          null &&
                                        String(
                                          account.field_force_custom_limit,
                                        ).trim() !== ""
                                          ? `INR ${formatCurrency(
                                              account.field_force_custom_limit,
                                            )}`
                                          : " "
                                      }
                                      titleColor="text-primary"
                                      subtitle={
                                        account?.field_force_custom_limit
                                          ? "Transaction limit"
                                          : ""
                                      }
                                      alignRight={false}
                                      hoverOption="white"
                                      isBold={false}
                                      variant="md"
                                    />
                                  </div>
                                </div> */}
                              </div>
                            </div>
                          ),
                        )}

                        {ViewAccountDetails?.map((account) => (
                          <div
                            className="Qmd:flex  Qmd:justify-end"
                            key={account?.id}
                          >
                            {showLoader ? (
                              <div className="w-max-button-width-for-approval-animation flex justify-end">
                                <div
                                  className={`w-width-full flex justify-center items-center ${
                                    clickedBtn === "reject"
                                      ? "bg-negative-act"
                                      : "bg-positive-act"
                                  } py-padding-lg`}
                                >
                                  <Loader
                                    height="var(--icon-lg)"
                                    width="var(--icon-lg)"
                                  />
                                </div>
                              </div>
                            ) : account?.approval_status === "approved" ? (
                              <div className="flex justify-end">
                                <TopNavLargeButton
                                  hoverOption={"black"}
                                  btnText={
                                    <>
                                      Pay <br /> now
                                    </>
                                  }
                                  btnType={"button"}
                                  handleFunction={() => {
                                    // if (
                                    //   payload?.type ===
                                    //   "field_force_account_detail_modal"
                                    // ) {
                                    //   actionRestricted();
                                    //   return;
                                    // }
                                    // const hasCreateTxnService =
                                    //   services?.find(
                                    //     (service) =>
                                    //       service === "CBeneficiaryTxn" ||
                                    //       service === "Admin",
                                    //   ) !== undefined;
                                    // if (!hasCreateTxnService) {
                                    //   navigate("/feature_not_assigned", {
                                    //     state: {
                                    //       unavailableService: "CBeneficiaryTxn",
                                    //     },
                                    //   });
                                    //   return;
                                    // }
                                    // if (
                                    //   !viewAccountDetailData
                                    //     ?.field_force_accounts?.[
                                    //     GlobalConfiguration.lengthCheckZero
                                    //   ]?.category?.length
                                    // ) {
                                    //   CommonToast({
                                    //     text: "Category can't be blank",
                                    //     icon: ICONS?.ERROR_WHITE_CIRCLE,
                                    //     variant: "var(--error)",
                                    //     btnProps: {
                                    //       isDisabled: false,
                                    //       enabledTextColor:
                                    //         "var(--text_primary)",
                                    //       enabledBgColor: "var(--primary_bg)",
                                    //     },
                                    //   });
                                    //   return;
                                    // }
                                    // navigate(
                                    //   "/field_force_transaction_dashboard/create_field_force_transaction",
                                    //   {
                                    //     state: {
                                    //       ...currentAccountDetails,
                                    //       type: "payFieldForceDetails",
                                    //     },
                                    //   },
                                    // );
                                    CommonToast({
                                      text: "Feature coming soon",
                                      icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
                                      variant: "var(--coming-soon)",
                                      buttonNeeded: false,
                                    });
                                  }}
                                  icon={ICONS?.PAY_WITH_CIRCLE}
                                  enabledBgColor={"var(--positive-act)"}
                                  enabledTextColor={"var(--text-primary)"}
                                  fullWidthRequired={isMobile}
                                />
                              </div>
                            ) : account?.approval_status === "rejected" &&
                              account?.error_msg?.length >
                                GlobalConfiguration?.lengthCheckZero ? (
                              <div className="pay-bene-box2 flex justify-end">
                                <div className="flex flex-row gap-x-gap-sm h-full w-full bg-negative-card p-padding-sm">
                                  <div className="flex place-items-center">
                                    <img
                                      src={
                                        ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                      }
                                      alt="Not found"
                                    />
                                  </div>
                                  <div className="flex flex-col justify-center gap-y-gap-xs w-width-lg">
                                    <span className="font-semibold font-sans text-xs text-text-primary">
                                      Failed to take action
                                    </span>
                                    <span className="font-sans text-font_xxs text-text-secondary text-ellipsis overflow-hidden w-full block">
                                      {account?.error_msg}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ) : account?.approval_status === "pending" &&
                              account?.error_msg?.length >
                                GlobalConfiguration?.lengthCheckZero ? (
                              <div className="pay-bene-box2 w-full lg:flex lg:justify-end">
                                <div className="flex flex-row h-full w-full bg-negative-card p-padding-sm gap-gap-sm">
                                  <div className="flex place-items-center">
                                    <img
                                      src={
                                        ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                      }
                                      alt="Not found"
                                      className="w-icon-lg h-icon-lg mr-margin-button-m"
                                    />
                                  </div>
                                  <div className="flex flex-col justify-center gap-gap-xs w-5/6">
                                    <span className="font-semibold font-sans text-sm text-text-primary">
                                      Failed to take action
                                    </span>
                                    <span className="font-sans text-xs text-text-secondary text-ellipsis overflow-hidden w-full block">
                                      {account?.error_msg}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ) : account?.approval_status === "error" ? (
                              <div className="flex flex-row h-full bg-negative-card p-padding-sm">
                                <div className="flex place-items-center">
                                  <img
                                    src={ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE}
                                    alt="Not found"
                                    className="w-icon-lg h-icon-lg mr-margin-button-m"
                                  />
                                </div>
                                <div className="flex flex-col justify-center gap-y-gap-xs w-5/6">
                                  <span className="font-semibold font-sans text-sm text-text-primary">
                                    Failed to take action
                                  </span>
                                  <p className="line-clamp-3 whitespace-wrap overflow-ellipsis text-font_xs text-text-secondary opacity-base_opacity">
                                    {account?.error_msg || "Unknown error."}
                                  </p>
                                </div>
                              </div>
                            ) : account?.approval_status === "pending" ? (
                              <div
                                key={account?.id}
                                className="pay-bene-box2 flex justify-end w-full"
                              >
                                <TopNavSmallButton
                                  btnText={
                                    <>
                                      Reject <br /> account
                                    </>
                                  }
                                  handleFunction={() => {
                                    if (
                                      services?.find(
                                        (service) =>
                                          service === "FFAAccount" ||
                                          service === "Admin",
                                      ) !== undefined
                                    ) {
                                      setClickedBtn("reject");
                                      handleDeclinedDetials(account?.id);
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "FFAAccount",
                                        },
                                      });
                                    }
                                  }}
                                  icon={
                                    "https://q2pay.in/new_assets/common/approval/reject_icon_red_with_white_circle.svg"
                                  }
                                  isDisabled={
                                    services?.find(
                                      (service) =>
                                        service === "FFAAccount" ||
                                        service === "Admin",
                                    ) === undefined
                                  }
                                  enabledBgColor={"var(--negative-act)"}
                                  enabledTextColor={"var(--text-primary"}
                                  hoverOption="black"
                                  fullWidthRequired={isMobile}
                                />
                                <TopNavSmallButton
                                  btnText={
                                    <>
                                      Approve <br /> account
                                    </>
                                  }
                                  handleFunction={() => {
                                    if (
                                      services?.find(
                                        (service) =>
                                          service === "FFAAccount" ||
                                          service === "Admin",
                                      ) !== undefined
                                    ) {
                                      setClickedBtn("approve");
                                      handleApprovalDetails(account?.id);
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "FFAAccount",
                                        },
                                      });
                                    }
                                  }}
                                  isDisabled={
                                    services?.find(
                                      (service) =>
                                        service === "FFAAccount" ||
                                        service === "Admin",
                                    ) === undefined
                                  }
                                  icon={
                                    "https://q2pay.in/new_assets/common/approval/approve_circle_green_checkmark.svg"
                                  }
                                  enabledBgColor={"var(--positive-act)"}
                                  enabledTextColor={"var(--text-primary"}
                                  hoverOption="black"
                                  fullWidthRequired={isMobile}
                                />
                              </div>
                            ) : null}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bene_quickaction_containerm block Qmd:hidden">
                <div className="text-text-primary pl-padding-sm py-padding-button-l text-font-sm font-semibold bg-primary-card">
                  Quick Actions
                </div>
                <div>
                  <div>
                    <div
                      className="associated-account-transaction-history-block Qmd:hidden flex flex-row border-b border-solid border-primary-bg"
                      style={{
                        borderTop:
                          payload.internalAccount === "internalAccount"
                            ? "var(--border) solid var(--primary-bg)"
                            : "none",
                      }}
                    >
                      <TopNavSmallButton
                        btnText={
                          <>
                            Associated <br /> accounts{" "}
                          </>
                        }
                        handleFunction={handleAssociatedAccountsClick}
                        icon={
                          "https://q2pay.in/new_assets/common/detail_page/associated_accounts_found.svg"
                        }
                        enabledBgColor={"var(--primary-nav-act)"}
                        enabledTextColor={"var(--text-primary"}
                        hoverOption="white"
                        isDisabled={
                          payload.type === "field_force_account_detail_modal"
                        }
                        fullWidthRequired={true}
                      />

                      <div className="flex">
                        <div className="flex-grow border-l border-solid border-primary-bg"></div>
                      </div>
                      <TopNavSmallButton
                        btnText={
                          <>
                            {" "}
                            Transaction <br /> history
                          </>
                        }
                        handleFunction={handleTransactionHistoryClick}
                        icon={
                          "https://q2pay.in/new_assets/common/detail_page/transaction_history.svg"
                        }
                        enabledBgColor={"var(--primary-nav-act)"}
                        enabledTextColor={"var(--text-primary"}
                        hoverOption="white"
                        isDisabled={
                          payload.type === "field_force_account_detail_modal"
                        }
                        fullWidthRequired={true}
                      />
                    </div>
                    <div className="settingsm flex flex-row">
                      {services?.find(
                        (service) =>
                          service === "BUAccount" || service === "Admin",
                      ) === undefined ||
                      viewAccountDetailData?.field_force_accounts[
                        GlobalConfiguration.lengthCheckZero
                      ].approval_status === "archived" ||
                      viewAccountDetailData?.field_force_accounts[
                        GlobalConfiguration.lengthCheckZero
                      ].approval_status === "blocked" ? (
                        <>
                          <TopNavSmallButton
                            btnText={
                              <>
                                Edit <br /> account
                              </>
                            }
                            handleFunction={() => {
                              if (
                                viewAccountDetailData?.field_force_accounts[
                                  GlobalConfiguration.lengthCheckZero
                                ].approval_status !== "archived" &&
                                viewAccountDetailData?.field_force_accounts[
                                  GlobalConfiguration.lengthCheckZero
                                ].approval_status !== "blocked"
                              ) {
                                if (
                                  services?.find(
                                    (service) =>
                                      service === "BUAccount" ||
                                      (service === "Admin" &&
                                        payload?.servicesType !== "BenAdmin"),
                                  ) !== undefined
                                ) {
                                  handleEditAccountClick();
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "BUAccount",
                                    },
                                  });
                                }
                              }
                            }}
                            icon={
                              "https://q2pay.in/new_assets/common/detail_page/edit_with_white_circle.svg"
                            }
                            enabledBgColor={"var(--primary-nav-act)"}
                            enabledTextColor={"var(--text-primary"}
                            hoverOption="white"
                            isDisabled={
                              payload.type ===
                                "field_force_account_detail_modal" ||
                              viewAccountDetailData?.field_force_accounts[
                                GlobalConfiguration.lengthCheckZero
                              ].approval_status === "archived" ||
                              viewAccountDetailData?.field_force_accounts[
                                GlobalConfiguration.lengthCheckZero
                              ].approval_status === "blocked"
                            }
                            fullWidthRequired={true}
                          />
                        </>
                      ) : (
                        <>
                          <TopNavSmallButton
                            btnText={
                              <>
                                Edit <br /> account
                              </>
                            }
                            handleFunction={() => {
                              if (
                                payload?.type !==
                                "field_force_account_detail_modal"
                              ) {
                                if (
                                  services?.find(
                                    (service) =>
                                      service === "BUAccount" ||
                                      service === "Admin",
                                  ) !== undefined
                                ) {
                                  handleEditAccountClick();
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "BUAccount",
                                    },
                                  });
                                }
                              } else if (
                                payload.type ===
                                "field_force_account_detail_modal"
                              ) {
                                actionRestricted();
                              }
                            }}
                            icon={
                              "https://q2pay.in/new_assets/common/detail_page/edit_with_white_circle.svg"
                            }
                            enabledBgColor={"var(--primary-nav-act)"}
                            enabledTextColor={"var(--text-primary"}
                            hoverOption="white"
                            isDisabled={
                              payload.type ===
                              "field_force_account_detail_modal"
                            }
                            fullWidthRequired={true}
                          />
                          {isEditModalOpen && (
                            <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
                              <EditCommonPopup
                                btnOneHandleFunction={handleEditModalClose}
                                headerTitle="Select the option you would like to edit:"
                                alertText="Make sure you understand the impact before archiving."
                                alertBackground="emphasis"
                                chipsArray={chipsArray}
                                btnOneText="Cancel"
                                btnOneEnabledBgColor="var(--primary-bg)"
                                btnOneEnabledTextColor="var(--text-primary)"
                                btnOneHoverOption="white"
                                btnOneOutLineColor="var(--text-primary)"
                                btnTwoText="Edit"
                                btnTwoHandleFunction={handleApply}
                                btnTwoIsDisabled={selectedChipIndex === null}
                                btnTwoEnabledBgColor="var(--text-primary)"
                                btnTwoEnabledTextColor="var(--primary-bg)"
                                btnTwoDisabledBgColor="var(--text-disabled)"
                                btnTwoHoverOption="black"
                              />
                            </div>
                          )}
                        </>
                      )}
                      <div className="flex">
                        <div className="flex-grow border-l border-solid border-primary-bg"></div>
                      </div>

                      {viewAccountDetailData?.field_force_accounts[
                        GlobalConfiguration.lengthCheckZero
                      ].approval_status === "blocked" ||
                      services?.find(
                        (service) =>
                          service === "FFAAccountArchive" ||
                          service === "Admin",
                      ) === undefined ? (
                        <>
                          <TopNavSmallButton
                            btnText={label}
                            handleFunction={() => {
                              if (
                                viewAccountDetailData?.field_force_accounts[
                                  GlobalConfiguration.lengthCheckZero
                                ].approval_status !== "blocked"
                              ) {
                                if (
                                  services?.find(
                                    (service) =>
                                      service === "FFAAccountArchive" ||
                                      service === "Admin",
                                  ) !== undefined
                                ) {
                                  handleUnarchive();
                                  handleArchive();
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "FFAAccountArchive",
                                    },
                                  });
                                }
                              }
                            }}
                            icon={
                              services?.find(
                                (service) =>
                                  service === "FFAAccountArchive" ||
                                  service === "Admin",
                              ) === undefined &&
                              viewAccountDetailData?.field_force_accounts[
                                GlobalConfiguration.lengthCheckZero
                              ].approval_status === "archived"
                                ? "https://q2pay.in/new_assets/common/detail_page/unarchive.svg"
                                : "https://q2pay.in/new_assets/common/detail_page/archive.svg"
                            }
                            enabledBgColor={"var(--primary-nav-act)"}
                            enabledTextColor={"var(--text-primary"}
                            hoverOption="white"
                            isDisabled={
                              payload.type ===
                                "field_force_account_detail_modal" ||
                              viewAccountDetailData?.field_force_accounts[
                                GlobalConfiguration.lengthCheckZero
                              ].approval_status === "blocked"
                            }
                            fullWidthRequired={true}
                          />
                        </>
                      ) : (
                        <TopNavSmallButton
                          btnText={
                            viewAccountDetailData?.field_force_accounts[
                              GlobalConfiguration.lengthCheckZero
                            ].approval_status === "archived" ? (
                              <>
                                Unarchive <br /> account{" "}
                              </>
                            ) : (
                              <>
                                Archive <br /> account{" "}
                              </>
                            )
                          }
                          handleFunction={() => {
                            if (
                              payload?.type !==
                              "field_force_account_detail_modal"
                            ) {
                              if (
                                services?.find(
                                  (service) =>
                                    service === "FFAAccountArchive" ||
                                    service === "Admin",
                                ) !== undefined
                              ) {
                                handleUnarchive();
                                handleArchive();
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "FFAAccountArchive",
                                  },
                                });
                              }
                            } else if (
                              payload.type ===
                              "field_force_account_detail_modal"
                            ) {
                              actionRestricted();
                            }
                          }}
                          icon={
                            viewAccountDetailData?.field_force_accounts[
                              GlobalConfiguration.lengthCheckZero
                            ].approval_status === "archived"
                              ? "https://q2pay.in/new_assets/common/detail_page/archive.svg"
                              : "https://q2pay.in/new_assets/common/detail_page/unarchive.svg"
                          }
                          enabledBgColor={"var(--primary-nav-act)"}
                          enabledTextColor={"var(--text-primary"}
                          hoverOption="white"
                          isDisabled={
                            payload.type === "field_force_account_detail_modal"
                          }
                          fullWidthRequired={true}
                        />
                      )}
                    </div>
                    <div className=" border-t border-primary-bg">
                      <TopNavSmallButton
                        btnText={
                          <>
                            Linked <br /> user
                          </>
                        }
                        handleFunction={handleLinkedUser}
                        icon="https://q2pay.in/new_assets/common/detail_page/linked_white_circle.svg"
                        enabledBgColor={"var(--primary-nav-act)"}
                        enabledTextColor={"var(--text-primary)"}
                        disabledBgColor={"var(--primary-nav-act)"}
                        disabledTextColor={"var(--text-primary)"}
                        isDisabled={
                          payload.type === "field_force_account_detail_modal"
                            ? true
                            : services?.find(
                                  (service) =>
                                    service === "VSpecificEmp" ||
                                    service === "Admin",
                                ) !== undefined &&
                                viewAccountDetailData?.field_force_accounts?.[
                                  GlobalConfiguration.lengthCheckZero
                                ]?.field_force_user_full_name
                              ? false
                              : viewAccountDetailData?.field_force_accounts?.[
                                    GlobalConfiguration.lengthCheckZero
                                  ]?.field_force_user_full_name
                                ? false
                                : true
                        }
                        hoverOption="white"
                        fullWidthRequired
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`bg-primary-bg flex-grow w-full ${payload.type === "field_force_account_detail_modal" && "pb-padding-lg"}`}
              >
                <div className="bg-primary-card w-full flex justify-center Qmd:mb-margin-base mb-margin-md ">
                  {/*  */}
                  <div className="Qlg:w-max-content-width w-full">
                    <CommonAlertsStrip alerts={buildAlerts()} />
                  </div>
                </div>
                {/* <AlertBar
                  sliceCategory={sliceCategory}
                  viewAccountDetailData={viewAccountDetailData}
                  AssociatedAccountlength={
                    beneLookData?.beneficiary_accounts?.length
                  }
                  beneTxnViewAllAccLoading={beneTxnViewAllAccLoading}
                  viewAccountDetailLoading={viewAccountDetailLoading}
                  schedulesTxnViewAllLoading={schedulesTxnViewAllLoading}
                  handleAssocaited={() => {
                    if (payload?.type === "field_force_account_detail_modal") {
                      actionRestricted();
                    } else {
                      openAssociatedAccountsFound();
                    }
                  }}
                  handleCategories={() => {
                    if (payload?.type === "field_force_account_detail_modal") {
                      actionRestricted();
                    } else {
                      toggleCategories();
                    }
                  }}
                  pendingTxnLength={pendingTxnId?.length}
                  schedulesTxnlength={
                    schedulesTxnViewAllData?.transactions?.length
                  }
                  handleSchedule={() => {
                    if (payload?.type === "field_force_account_detail_modal") {
                      actionRestricted();
                    }

                    const hasAccess =
                      services?.includes("BAScheduledTxn") ||
                      services?.includes("Admin");

                    if (!hasAccess) {
                      navigate("/feature_not_assigned", {
                        state: { unavailableService: "BAScheduledTxn" },
                      });
                      return;
                    }

                    setShowScheduleTxnPopup(true);
                    setassociateschedule("AlertSchedule");
                    setassociatePending("");
                  }}
                  handlePending={() => {
                    if (payload?.type === "field_force_account_detail_modal") {
                      actionRestricted();
                      return;
                    }

                    const hasAccess =
                      services?.includes("ABeneficiaryTxn") ||
                      services?.includes("Admin");

                    if (!hasAccess) {
                      navigate("/feature_not_assigned", {
                        state: { unavailableService: "ABeneficiaryTxn" },
                      });
                      return;
                    }

                    setRejectTxnPopup(true);
                    setassociatePending("AlertPendingTxn");
                    setassociateschedule("");
                  }}
                  opacityvalue={
                    payload?.type === "field_force_account_detail_modal"
                      ? "light-opacity"
                      : ""
                  }
                  hoverEnable={
                    payload?.type === "field_force_account_detail_modal" ? false : true
                  }
                  cursorPointRequired={
                    payload?.type === "field_force_account_detail_modal"
                      ? "not-allowed"
                      : "pointer"
                  }
                /> */}
                <div className="h-auto max-w-tab-width-normal bg-primary-bg m-auto pb-padding-md">
                  <div className="z-z-index-base relative detail-category-button flex Qmd:pt-padding-md pb-padding-md px-padding-md Qlg:px-padding-base">
                    <div className="Qsm:overflow-x-hidden overflow-x-scroll no-scrollbar">
                      <SwitcherTabs
                        tabs={[
                          {
                            label: "Details",
                            key: "Details",
                            handler: toggleContactDetails,
                          },
                          {
                            label: "Categories",
                            key: "Categories",
                            handler: toggleCategories,
                          },
                          {
                            label: "Labels",
                            key: "Labels",
                            handler: toggleAssignedLabels,
                          },
                          {
                            label: "Recipients",
                            key: "Recipients",
                            handler: toggleAdditionalRecipicent,
                          },
                        ]}
                        swicherTabBgColor={"var(--primary-card)"}
                        initialActiveTab={
                          index === GlobalConfiguration?.lengthCheckOne
                            ? "Categories"
                            : index === GlobalConfiguration?.lengthCheckTwo
                              ? "Labels"
                              : index === GlobalConfiguration?.lengthCheckThree
                                ? "Recipients"
                                : "Details"
                        }
                        setIndex={setIndex}
                      />
                    </div>
                  </div>

                  <div className="relative">
                    {index === GlobalConfiguration?.lengthCheckZero && (
                      <div className={animationClass}>
                        {ViewAccountDetails?.map((account) => {
                          let originItemList = [
                            {
                              content: "+91 " + account.contact_no ?? "",
                              heading: "Contact number",
                              type: "text",
                            },
                            {
                              content: account?.email_id?.toLowerCase(),
                              heading: "Email ID",
                              type: "text",
                            },
                          ];

                          let AccountItemList = [
                            {
                              content: account?.pan_no,
                              heading: "PAN number",
                              type: "text",

                              onClick: () => {
                                const hasAccess = services?.some(
                                  (service) =>
                                    service === "VPAN" || service === "Admin",
                                );

                                if (hasAccess && account?.pan_no) {
                                  if (
                                    payload.type ===
                                    "field_force_account_detail_modal"
                                  ) {
                                    actionRestricted();
                                  } else {
                                    handlePANDetails(account.pan_no);
                                  }
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: { unavailableService: "VPAN" },
                                  });
                                }
                              },

                              isDisabled:
                                services?.some(
                                  (service) =>
                                    service === "VPAN" || service === "Admin",
                                ) &&
                                account?.pan_no &&
                                payload.type !==
                                  "field_force_account_detail_modal"
                                  ? false
                                  : true,
                            },

                            {
                              content: account?.pan_legal_name
                                ?.toLowerCase()
                                ?.split(" ")
                                ?.map(
                                  (word) =>
                                    word
                                      .charAt(
                                        GlobalConfiguration?.lengthCheckZero,
                                      )
                                      .toUpperCase() +
                                    word.slice(
                                      GlobalConfiguration?.lengthCheckOne,
                                    ),
                                )
                                ?.join(" "),
                              heading: "Legal name",
                              type: "text",
                            },
                            {
                              content: account.gstin_detail
                                ? account.gstin_detail
                                : "Not Given",
                              heading: "GST number",
                              type: "text",

                              onClick: account?.gstin_detail
                                ? () => {
                                    if (
                                      payload.type ===
                                      "field_force_account_detail_modal"
                                    ) {
                                      actionRestricted();
                                    } else {
                                      const hasAccess =
                                        services?.includes("VGSTIN") ||
                                        services?.includes("Admin");

                                      if (hasAccess) {
                                        setGstShowPopup(true);
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService: "VGSTIN",
                                          },
                                        });
                                      }
                                    }
                                  }
                                : undefined,
                              isDisabled:
                                payload.type ===
                                  "field_force_account_detail_modal" &&
                                !account.gstin_detail
                                  ? false
                                  : !(
                                      services?.some(
                                        (s) => s === "VPAN" || s === "Admin",
                                      ) &&
                                      account?.pan_no &&
                                      payload.type !==
                                        "field_force_account_detail_modal"
                                    ),
                            },

                            ...(account?.virtual_account === "Y"
                              ? [
                                  {
                                    content:
                                      account?.virtual_account === "N"
                                        ? ""
                                        : account?.virtual_account_type ===
                                            "manual"
                                          ? "Manually created"
                                          : account?.virtual_account_type ===
                                              "automated" && "Auto detected",
                                    heading:
                                      account?.virtual_account === "N"
                                        ? ""
                                        : "Virtual account",
                                    type: "text",
                                  },
                                ]
                              : []),
                          ];
                          let originTimelineItemList = [
                            {
                              content: account.created_by_name || "Not given",
                              heading: "Created by",
                              type: "text",
                            },
                            {
                              content: account.created_on
                                ? formatDateViewAll(
                                    account.created_on,
                                    true,
                                    true,
                                  )
                                : "Not given",
                              heading: "Created on",
                              type: "text",
                            },

                            // ✅ APPROVED
                            ...(account.approval_status === "approved"
                              ? [
                                  {
                                    content:
                                      account.approved_by_name || "Not given",
                                    heading: "Approved by",
                                    type: "text",
                                  },
                                  {
                                    content: account.approved_on
                                      ? formatDateViewAll(
                                          account.approved_on,
                                          true,
                                          true,
                                        )
                                      : "Not given",
                                    heading: "Approved on",
                                    type: "text",
                                  },
                                ]
                              : []),

                            // ✅ REJECTED
                            ...(account.approval_status === "rejected"
                              ? [
                                  {
                                    content:
                                      account.rejected_by_name || "Not given",
                                    heading: "Rejected by",
                                    type: "text",
                                  },
                                  {
                                    content: account.rejected_on
                                      ? formatDateViewAll(
                                          account.rejected_on,
                                          true,
                                          true,
                                        )
                                      : "Not given",
                                    heading: "Rejected on",
                                    type: "text",
                                  },
                                  {
                                    content:
                                      account.rejection_reason || "Not given",
                                    heading: "Rejected reason",
                                    type: "text",
                                  },
                                ]
                              : []),

                            // ✅ ARCHIVED
                            ...(account.approval_status === "archived"
                              ? [
                                  {
                                    content:
                                      account.archived === "Y" &&
                                      !account.archived_by_name
                                        ? nameArchive
                                        : account.archived_by_name ||
                                          "Not given",
                                    heading: "Archived by",
                                    type: "text",
                                  },
                                  {
                                    content: account.archived_on
                                      ? formatDateViewAll(
                                          account.archived_on,
                                          true,
                                          true,
                                        )
                                      : "Not given",
                                    heading: "Archived on",
                                    type: "text",
                                  },
                                ]
                              : []),

                            // ✅ BLOCKED
                            ...(account.approval_status === "blocked"
                              ? [
                                  {
                                    content:
                                      account.blocked_by_name || "Not given",
                                    heading: "Blocked by",
                                    type: "text",
                                  },
                                  {
                                    content: account.blocked_on
                                      ? formatDateViewAll(
                                          account.blocked_on,
                                          true,
                                          true,
                                        )
                                      : "Not given",
                                    heading: "Blocked on",
                                    type: "text",
                                  },
                                ]
                              : []),
                          ];

                          let SupportInformationList = [
                            {
                              content: account.id,
                              heading: "Field force account ID",
                              type: "text",
                            },
                          ];

                          return (
                            <div className="flex flex-col lg:flex-row justify-around mb-margin-xl gap-gap-md mx-margin-md lg:mx-auto">
                              <CommonDetailCard
                                cardTitle="Contact Details"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="fourth"
                                entries={originItemList}
                              />
                              <CommonDetailCard
                                cardTitle="Account Details"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="fourth"
                                entries={AccountItemList}
                              />
                              <CommonDetailCard
                                cardTitle="Origin Details"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="fourth"
                                entries={originTimelineItemList}
                              />
                              <CommonDetailCard
                                cardTitle="Support Information"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="fourth"
                                entries={SupportInformationList}
                                // icon="https://q2pay.in/new_assets/common/detail_page/field_force_accounts_linear.svg"
                              />
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {index === GlobalConfiguration?.lengthCheckOne && (
                      <div className={animationClass}>
                        <CommonContainerCard
                          header={TEXT?.ASSIGNED_BENEFICIARY_CATEGORIES}
                        >
                          {sliceCategory.filter((item) => item.active === "Y")
                            .length ===
                          viewAccountDetailData?.field_force_accounts?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.category.split(",").length ? (
                            <div className="flex mb-margin-button-l items-center">
                              <img
                                className="w-icon-md h-icon-md mr-margin-sm"
                                src={
                                  "https://q2pay.in/new_assets/common/dashboard/alert.svg"
                                }
                                alt=""
                              />
                              <p className="text-text-primary text-sm font-normal">
                                {TEXT?.ALL_CATEGORIES_ASSIGNED_WARNING}
                              </p>
                            </div>
                          ) : (
                            ""
                          )}
                          <div
                            className={`${
                              viewAccountDetailData?.field_force_accounts?.[
                                GlobalConfiguration.lengthCheckZero
                              ]?.category.length >
                              GlobalConfiguration?.lengthCheckZero
                                ? "assigned-beneficiary-categories-data-div"
                                : ""
                            }`}
                          >
                            {viewAccountDetailData?.field_force_accounts.map(
                              (account, index) => (
                                <div key={index}>
                                  <Box className="flex flex-col Qmd:flex-row Qmd:flex-wrap gap-gap-sm">
                                    {account.category
                                      ? account.category
                                          .split(",")
                                          .map((category, categoryIndex) => (
                                            <div
                                              className="category-card max-w-none Qmd:max-w-detail-page-category-grid flex flex-row items-center"
                                              key={categoryIndex}
                                            >
                                              <div className="bene-category-img flex justify-center items-center opacity-base-opacity">
                                                <img
                                                  className="w-icon-lg h-icon-lg cateImage max-w-none"
                                                  src={categoryMapper(category)}
                                                  alt="bene"
                                                />
                                              </div>
                                              <div className="truncate px-padding-sm text-sm text-text-primary text-left font-sans font-semibold opacity-base-opacity antialiased">
                                                <TickerAnimation
                                                  text={category.trim()}
                                                />
                                              </div>
                                            </div>
                                          ))
                                      : null}
                                  </Box>
                                  {!account.category && (
                                    <p
                                      key={`notFound_${index}`}
                                      className="antialiased text-text-primary text-sm"
                                    >
                                      {TEXT?.ASSIGN_CATEGORY_WARNING}
                                    </p>
                                  )}
                                </div>
                              ),
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    )}

                    {index === GlobalConfiguration?.lengthCheckTwo && (
                      <div className={animationClass}>
                        <CommonContainerCard
                          header="Assigned Labels"
                          subheader="Labels will be used to generate statistics for the
                                              associated accounts."
                          handleFunction={(e) => {
                            e.stopPropagation();
                            if (
                              !services?.includes("ALabel") &&
                              !services?.includes("RLabel")
                            ) {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "ALabel,RLabel",
                                },
                              });
                              return;
                            }
                            if (
                              payload?.type ===
                              "field_force_account_detail_modal"
                            ) {
                              actionRestricted();
                              return;
                            }
                            if (!isArchived) {
                              setShowLabelsPopup(true);
                            }
                          }}
                          icon={
                            "https://q2pay.in/new_assets/common/create_flow/edit.svg"
                          }
                          iconIsDisabled={
                            payload?.type === "field_force_account_detail_modal"
                              ? true
                              : isArchived
                          }
                        >
                          <div className="flex flex-wrap w-full gap-gap-sm">
                            {Array.isArray(labelDetails) &&
                            labelDetails.length >
                              GlobalConfiguration.lengthCheckZero ? (
                              <>
                                {labelDetails.map((item, index) => (
                                  <Box
                                    key={index}
                                    className="px-padding-button-l py-padding-button-m flex rounded-border-radius-md bg-primary-nav max-w-full"
                                  >
                                    <div className="text-text-primary text-font-xs inline-block truncate">
                                      {item}
                                    </div>
                                  </Box>
                                ))}
                              </>
                            ) : (
                              <p className="text-font-sm text-text-primary">
                                No labels assigned.
                              </p>
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    )}
                    {index === GlobalConfiguration?.lengthCheckThree && (
                      <div className={animationClass}>
                        <CommonContainerCard
                          header={TEXT?.ADDITIONAL_RECIPIENTS}
                          subheader={TEXT?.ADDITIONAL_RECIPIENTS_CARD_SUBTEXT}
                          icon={
                            "https://q2pay.in/new_assets/common/create_flow/edit.svg"
                          }
                          handleFunction={(e) => {
                            e.stopPropagation();
                            if (!ensureAll(["BUAccount"]).status) {
                              navigate("/feature_not_assigned", {
                                state: { unavailableService: "BUAccount" },
                              });
                              return;
                            }
                            if (
                              payload?.type ===
                              "field_force_account_detail_modal"
                            ) {
                              actionRestricted();
                              return;
                            } else if (
                              ViewAccountDetails[
                                GlobalConfiguration.lengthCheckZero
                              ].approval_status === "archived" ||
                              ViewAccountDetails[
                                GlobalConfiguration.lengthCheckZero
                              ].approval_status === "blocked"
                            ) {
                              return;
                            } else {
                              setShowAdditionalSection(true);
                              setAdditionalChip(showAdditionalRecipient);
                            }
                          }}
                          iconIsDisabled={
                            !ensureAll(["BUAccount"]).status
                              ? true
                              : ViewAccountDetails[
                                    GlobalConfiguration.lengthCheckZero
                                  ].approval_status === "archived" ||
                                  ViewAccountDetails[
                                    GlobalConfiguration.lengthCheckZero
                                  ].approval_status === "blocked"
                                ? true
                                : payload?.type ===
                                    "field_force_account_detail_modal"
                                  ? true
                                  : false
                          }
                        >
                          <div className="flex flex-wrap w-full gap-gap-sm">
                            {Array.isArray(showAdditionalRecipient) &&
                            showAdditionalRecipient.length >
                              GlobalConfiguration?.lengthCheckZero ? (
                              <>
                                {showAdditionalRecipient.map((item, index) => (
                                  <div
                                    key={index}
                                    className="flex flex-row items-center py-padding-button-m px-padding-button-l rounded-border-radius-md relative bg-primary-nav-act max-w-max_width-full"
                                  >
                                    <span className="text-text-primary text-font-xs font-normal truncate">
                                      {linkIdentifier(item)}
                                    </span>
                                  </div>
                                ))}
                              </>
                            ) : (
                              <span className="text-text-primary text-sm font-normal">
                                {TEXT?.NO_ADDITIONAL_RECIPIENTS_ADDED}
                              </span>
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default FieldForceAccountDetails;
